import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Button,
  Input,
} from "reactstrap";

// Keep your project's utilities
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import { showSuccessToast, showErrorToast } from "../../../../_services/notification";
import { API_BASE_URL } from "../../../../_services/constant";
import Subcategory from "../product_subcategory/subcategory";
import { Category } from "@mui/icons-material";
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { Note } from "@material-ui/icons";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddCustomerSales = (props) => {
  const history = useHistory();
  const query = useQuery();
  const idParamRaw = query.get("id");
  const idParam = idParamRaw === "" ? null : idParamRaw;

  // ---------------- state ----------------
  const [loading, setLoading] = useState(false);
  const [productlist, setProductlist] = useState([]);
  const [searchProduct, setSearchProduct] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const [selectedProducts, setSelectedProducts] = useState([]); 
  const [param, setParam] = useState({
    tran_id: idParam == null ? "0" : idParam,
    entry_no: "",
    title: "Sale",
    mobile: "",
    customer_id: "",
    customer_name: "",
    remarks: "",
    staff_id: "",
    gst: 0,
    address: ""
  });

  const [branchDetails, setBranchDetails] = useState({});
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailProduct, setDetailProduct] = useState(null);

  const [showBillModal, setShowBillModal] = useState(false);
  const [billData, setBillData] = useState(null);
  const [stockErrors, setStockErrors] = useState({});

  // voucher & points
  const [CustomerPointList, setCustomerPointList] = useState([]);
  const [totalPoint, setTotalPoint] = useState(0);
  const [redeemPoint, setRedeemPoint] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [extraCharge, setExtraCharge] = useState({
    name: "",
    amount: ""
  });
  const [note, setNote] = useState("");
  const [CustomerVoucherList, setCustomerVoucherList] = useState([]);
  const [voucherCount, setVoucherCount] = useState(0);
  const [voucherDetail, setVoucherDetail] = useState({ tran_id: "", voucher_id: "", voucher_name: "", amount: "" });

  // ----------new Search apply----------
  const [searchProductsList, setSearchProductsList] = useState([]);
  const [searchProductsLoading, setSearchProductsLoading] = useState(false);
  const searchProductsForSelection = () => {
    if (!searchProduct.trim()) {
      showErrorToast("Enter search text");
      return;
    }

    setSearchProductsLoading(true);

    postMethod(
      "api/transactions/customer/session/getProductsbyProductCodeRetailer",
      {
        search: searchProduct,
      }
    )
      .then((res) => {

        const data = (res.data || []).map((item) => {

          const alreadyAdded = selectedProducts.find(
            x => x.product_id === item.product_id
          );

          return {
            ...item,
            sale_qty: alreadyAdded
              ? alreadyAdded.sale_qty
              : 1
          };
        });

        setSearchProductsList(data);
      })
      .catch(() => {
        showErrorToast("Search failed");
      })
      .finally(() => {
        setSearchProductsLoading(false);
      });
  };
  const handleSearchProductSelect = (checked, obj) => {

    if (checked) {

      if (Number(obj.sale_qty) > Number(obj.qty)) {
        showErrorToast(
          "Qty cannot exceed available qty"
        );
        return;
      }

      const exist = selectedProducts.find(
        x => x.product_id === obj.product_id
      );

      if (!exist) {

        setSelectedProducts(prev => [
          ...prev,
          {
            ...obj,
            stock_qty: obj.qty,
            qty: Number(obj.sale_qty),
            sale_qty: Number(obj.sale_qty)

          }
        ]);

        setProductlist(prev => [
          ...prev,
          {
            ...obj,
            stock_qty: obj.qty,
            qty: Number(obj.sale_qty),
            sale_qty: Number(obj.sale_qty)
          }
        ]);
      }

    } else {

      setSelectedProducts(prev =>
        prev.filter(
          x => x.product_id !== obj.product_id
        )
      );

      setProductlist(prev =>
        prev.filter(
          x => x.product_id !== obj.product_id
        )
      );
    }
  };

  const handleSearchQtyChange = (
    value,
    index,
    obj
  ) => {

    const temp = [...searchProductsList];

    temp[index].sale_qty = value;

    setSearchProductsList(temp);

    if (value === "") {
      return;
    }

    const qty = Number(value);

    // agar already selected hai to update kro

    const selectedIndex =
      selectedProducts.findIndex(
        x => x.product_id === obj.product_id
      );

    if (selectedIndex > -1) {

      setSelectedProducts(prev =>
        prev.map(item =>
          item.product_id === obj.product_id
            ? {
              ...item,
              qty,
              sale_qty: qty
            }
            : item
        )
      );

      setProductlist(prev =>
        prev.map(item =>
          item.product_id === obj.product_id
            ? {
              ...item,
              qty,
              sale_qty: qty
            }
            : item
        )
      );
    }
  };


  const [billingSummary, setBillingSummary] = useState({
    redeemPoint: 0,
    voucher_id: "",
    voucher_name: "",
    special_discount: "",
    totalDiscount: "0.00",
    IGST: "0.00",
    CGST: "0.00",
    SGST: "0.00",
    subtotal_after_discount: "0.00",
    final_amount: "0.00",
  });
  // ---------------- helpers ----------------
  const mergeAppendProducts = (existing = [], incoming = []) => {
    const map = new Map();
    existing.forEach((p) => map.set(p.product_id, { ...p }));
    incoming.forEach((p) => {
      if (!map.has(p.product_id)) {
        // ensure sale_qty exists
        map.set(p.product_id, { ...p, sale_qty: p.sale_qty ? Number(p.sale_qty) : 0 });
      } else {
        // keep existing; but if existing lacks sale_qty and incoming has, update it
        const exist = map.get(p.product_id);
        if ((!exist.sale_qty || exist.sale_qty === "") && p.sale_qty) exist.sale_qty = Number(p.sale_qty);
        map.set(p.product_id, exist);
      }
    });
    return Array.from(map.values());
  };

  const findSelectedIndex = (product_id) =>
    selectedProducts.findIndex((x) => x.product_id === product_id);

  const updateModalProductQty = (product_id, qty = "") => {
    setModalProducts((prev) =>
      prev.map((item) =>
        item.product_id === product_id
          ? { ...item, sale_qty: qty }
          : item
      )
    );
  };

  const updateModalQty = (product_id, qty = "") => {
    setModalProducts((prev) =>
      prev.map((item) =>
        item.product_id === product_id
          ? { ...item, sale_qty: qty }
          : item
      )
    );
  };

  const addOrRemoveProduct = (product, qty = 1) => {
    const existingIndex = selectedProducts.findIndex(
      (x) => x.product_id === product.product_id
    );

    // REMOVE
    if (existingIndex > -1) {
      setSelectedProducts((prev) =>
        prev.filter((x) => x.product_id !== product.product_id)
      );

      // main table sync
      setProductlist((prev) =>
        prev.map((item) =>
          item.product_id === product.product_id
            ? {
              ...item,
              sale_qty: 0,
              qty: 0,
            }
            : item
        )
      );

      return;
    }

    // ADD
    const newProduct = {
      ...product,
      qty: Number(qty),
      sale_qty: Number(qty),
    };

    setSelectedProducts((prev) => [...prev, newProduct]);

    // sync main table
    setProductlist((prev) =>
      prev.map((item) =>
        item.product_id === product.product_id
          ? {
            ...item,
            sale_qty: Number(qty),
            qty: Number(qty),
          }
          : item
      )
    );
  };

  useEffect(() => {
    setModalProducts((prev) =>
      prev.map((item) => {
        const selectedItem = selectedProducts.find(
          (x) => x.product_id === item.product_id
        );

        return {
          ...item,
          sale_qty: selectedItem ? selectedItem.sale_qty : item.sale_qty ?? 1,
        };
      })
    );
  }, [selectedProducts]);

  // ---------------- API / effects ----------------
  const [staffList, setStaffList] = useState([]);
  const getStaffList = () => {
    postMethod("api/customervisit/StaffList").then((res) => {
      setStaffList(res.data);
    });
  };


  useEffect(() => {
    // initial load
    setLoading(true);

    getStaffList();
    // get branch details
    const branchId = localStorage.getItem("jwl_branch_id");
    if (branchId) {
      postMethod("api/masters/branch/preview", { branch_id: branchId })
        .then((d) => setBranchDetails(d))
        .catch((e) => console.error("branch preview error", e));
    }

    const runPreview = async () => {
      try {
        if (idParam !== null) {
          const temp = window.atob(idParam);
          const dataD = await postMethod("api/transactions/stockReatilerSales/preview", { tran_id: temp });
          const data = dataD.data && dataD.data[0];
          if (data) {
            setParam((p) => ({
              ...p,
              tran_id: temp,
              entry_no: data.entry_no,
              title: data.title || p.title,
              mobile: data.mobile,
              customer_id: data.customer_id,
              customer_name: data.customer_name,
              remarks: data.remarks,
              staff_id: "",
              gst: data.gst,
            }));
            setSelectedProducts(data.products || []);
          }
        } else {
          const dataD = await postMethod("api/transactions/stockReatilerSales/preview", { tran_id: 0 });
          const data = dataD.data && dataD.data[0];
          if (data) setParam((p) => ({ ...p, entry_no: data.entry_no }));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    runPreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkMobile = (val) => {
    setParam((p) => ({ ...p, mobile: val }));
    if ((val + "").length !== 10) {
      return; // do not query if not 10 digits
    }

    postMethod("api/transactions/customer/session/getCustomer", { mobile: val })
      .then((dataD) => {
        const data = dataD.data && dataD.data[0];
        if (data) {
          setParam((p) => ({ ...p, customer_name: data.full_name, customer_id: data.customer_id, mobile: data.mobile, address: data.address }));
          setRedeemPointData((a) => ({ ...a, full_name: data.full_name, customer_id: data.customer_id, mobile: data.mobile }));
          setRedeemVoucherData({ ...redeemVoucherData, customer_id: data.customer_id });
          handleCustomerPointList(data.customer_id);
          handleCustomerVoucherList(data.customer_id);
        } else {
          setParam((p) => ({ ...p, customer_name: "", customer_id: null, mobile: val }));
        }
      })
      .catch((e) => console.error("getCustomer error", e));
  };


  const searchProductFun = () => {
    if (!searchProduct || searchProduct.trim() === "") {
      showErrorToast("Please enter a product code / search text");
      return;
    }

    setSearchLoading(true);

    postMethod("api/transactions/customer/session/getProductsbyProductCode", {
      search: searchProduct,
    })
      .then((res) => {

        if (!res.data || res.data.length === 0) {
          showErrorToast("The product doesn't exist");
          return;
        }

        const outOfStockProducts = (res.data || []).filter(
          p => Number(p.qty) <= 0
        );

        if (outOfStockProducts.length > 0) {
          showErrorToast(
            `${outOfStockProducts[0].product_name} quantity is 0`
          );
          return;
        }

        const updatedData = (res.data || [])
          .filter(p => Number(p.qty) > 0)
          .map((p) => ({
            ...p,
            stock_qty: p.qty,
            sale_qty: 1,
            qty: 1,
          }));
        // product list maintain
        setProductlist((prev) => {
          let updated = [...prev];

          updatedData.forEach((product) => {
            const existingIndex = updated.findIndex(
              (x) => x.product_id === product.product_id
            );

            if (existingIndex > -1) {
              // qty increase
              updated[existingIndex].sale_qty =
                Number(updated[existingIndex].sale_qty || 0) + 1;

              updated[existingIndex].qty =
                Number(updated[existingIndex].qty || 0) + 1;
            } else {
              updated.push({
                ...product,
                sale_qty: 1,
                qty: 1,
              });
            }
          });

          return [...updated];
        });

        // selected products maintain
        setSelectedProducts((prev) => {
          let updated = [...prev];

          updatedData.forEach((product) => {
            const existingIndex = updated.findIndex(
              (x) => x.product_id === product.product_id
            );

            if (existingIndex > -1) {
              updated[existingIndex].sale_qty =
                Number(updated[existingIndex].sale_qty || 0) + 1;

              updated[existingIndex].qty =
                Number(updated[existingIndex].qty || 0) + 1;
            } else {
              updated.push({
                ...product,
                sale_qty: 1,
                qty: 1,
              });
            }
          });

          return [...updated];
        });

        setSearchProduct("");
      })
      .catch((err) => {
        console.error(err);
        showErrorToast("Search failed");
      })
      .finally(() => setSearchLoading(false));
  };

  const [modalProducts, setModalProducts] = useState([]);
  const searchProductFun2 = (searchVal) => {
    if (!searchVal) return;

    postMethod(
      "api/transactions/customer/session/getProductsbyProductCodeRetailer",
      { search: searchVal }
    )
      .then((res) => {
        //        const data = (res.data || []).map((p) => {
        //   const existing = selectedProducts.find(
        //     (x) => x.product_id === p.product_id
        //   );

        //   return {
        //     ...p,
        //     sale_qty: existing ? existing.sale_qty : 0,
        //   };
        // });
        const data = (res.data || [])
          .filter(p => Number(p.qty) > 0)
          .map((p) => {
            const existing = selectedProducts.find(
              (x) => x.product_id === p.product_id
            );

            return {
              ...p,
              sale_qty: existing ? existing.sale_qty : 0,
            };
          });
        setModalProducts((prev) => {
          const merged = [...data];

          return merged.map((item) => {
            const selected = selectedProducts.find(
              (x) => x.product_id === item.product_id
            );

            return {
              ...item,
              sale_qty: selected ? selected.sale_qty : 0,
            };
          });
        });
      })
      .catch((err) => {
        console.error(err);
        showErrorToast("Search failed");
      });
  };
  const handleDeleteEntry = () => {
    const proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (!proceed) return;
    postMethod("api/transactions/customer/session/delete", { tran_id: param.tran_id })
      .then((data) => {
        const res = data.data && data.data[0];
        if (res && res.valid) {
          showSuccessToast("Deleted");
          history.push("/branch/customer/session");
        } else {
          showErrorToast(res?.error || "Could not delete");
        }
      })
      .catch((e) => {
        console.error("delete error", e);
        showErrorToast("Delete failed");
      });
  };


  const toggleDetail = (product) => {
    setDetailProduct(product || null);
    setShowDetailsModal(true);
    const parts = (product?.product_code || "").split("/");
    if (parts.length >= 2) {
      const s = parts.slice(0, 2).join("/");
      searchProductFun2(s);
    }
  };

  const closeDetail = () => {

    // ✅ Sync modal products into main table
    setProductlist((prev) => {

      let updated = [...prev];

      modalProducts.forEach((modalItem) => {

        const existingIndex = updated.findIndex(
          (x) => x.product_id === modalItem.product_id
        );

        // agar already hai → update qty
        if (existingIndex > -1) {

          updated[existingIndex] = {
            ...updated[existingIndex],
            sale_qty: Number(modalItem.sale_qty || 0),
            qty: Number(modalItem.sale_qty || 0),
          };

        } else if (Number(modalItem.sale_qty || 0) > 0) {

          // ✅ new sub product add
          updated.push({
            ...modalItem,
            sale_qty: Number(modalItem.sale_qty || 0),
            qty: Number(modalItem.sale_qty || 0),
          });
        }
      });

      // remove zero qty rows
      return updated.filter((x) => Number(x.sale_qty || 0) > 0);
    });

    // ✅ sync selected products also

    setSelectedProducts((prev) => {
      let updated = [...prev];

      modalProducts.forEach((modalItem) => {
        const idx = updated.findIndex(
          (x) => x.product_id === modalItem.product_id
        );

        const qty = Number(modalItem.sale_qty || 0);

        if (idx > -1) {
          if (qty > 0) {
            updated[idx] = {
              ...updated[idx],
              sale_qty: qty,
              qty: qty,
            };
          } else {
            updated.splice(idx, 1);
          }
        } else if (qty > 0) {
          updated.push({
            ...modalItem,
            sale_qty: qty,
            qty: qty,
          });
        }
      });

      return updated;
    });

    setDetailProduct(null);
    setShowDetailsModal(false);
    setModalProducts([]);
  };

  const buildPrintHtml = () => {
    const activeBillData = billData || {
      customer: param.customer_name || "-",
      entry_no: param.entry_no,
      mobile: param.mobile || "-",
      products: [...selectedProducts],
      subtotal: selectedProducts.reduce((acc, item) => acc + (Number(item.price) * Number(item.qty || 0)), 0),
      totalItems: selectedProducts.reduce((acc, item) => acc + Number(item.qty || 0), 0),
      special_discount: "",
    };

    const subtotal = activeBillData.products.reduce((acc, p) => {
      const gstPercent = Number(p.gst) || 0;
      const priceWithGST = Number(p.price) || 0;
      const priceWithoutGST =
        branchDetails?.gst_type === "Inclusive"
          ? priceWithGST / (1 + gstPercent / 100)
          : priceWithGST;

      return acc + priceWithoutGST * Number(p.qty || 0);
    }, 0);

    // 🎯 Point Discount
    const pointPerRs = Number(branchDetails?.rupees_per_point) || 0;
    const pointDiscountRaw =
      redeemPoint ? (pointPerRs > 0 ? Number(redeemPoint) / pointPerRs : Number(redeemPoint)) : 0;

    // 🎟 Voucher Discount
    let voucherDiscountRaw = 0;
    const voucherAmt = voucherDetail?.amount || "";

    if (voucherAmt.includes("%")) {
      const percent = parseFloat(voucherAmt);
      voucherDiscountRaw = (subtotal * percent) / 100;
    } else {
      voucherDiscountRaw = parseFloat(voucherAmt.replace(/[^0-9.]/g, "")) || 0;
    }

    // ✳️ Special Discount
    const sp = activeBillData.special_discount || "";
    const isPercent = sp.includes("%");
    const specialDiscountRaw = isPercent
      ? (subtotal * parseFloat(sp)) / 100
      : parseFloat(sp || 0);
    const chargeAmountRaw = Number(extraCharge.amount || 0);
    let pointDiscount = pointDiscountRaw;
    let voucherDiscount = voucherDiscountRaw;
    let specialDiscount = specialDiscountRaw;
    let chargeAmount = chargeAmountRaw;

    if (branchDetails?.gst_type === "Inclusive") {
      const gstPercent =
        billData.products?.length > 0
          ? Number(billData.products[0].gst || 0)
          : 0;

      const divisor = 1 + gstPercent / 100;

      pointDiscount = pointDiscountRaw / divisor;
      voucherDiscount = voucherDiscountRaw / divisor;
      specialDiscount = specialDiscountRaw / divisor;
      chargeAmount = chargeAmountRaw / divisor;
    }

    const subtotalAfterDiscounts = Math.max(
      subtotal - (pointDiscount + voucherDiscount + specialDiscount),
      0
    );

    const subtotalAfterExtraCharges =
      subtotalAfterDiscounts + chargeAmount;

    // 💰 GST
    let cgst = 0,
      sgst = 0,
      igst = 0,
      gstPercent = 0;

    if (activeBillData.products.length > 0) {
      gstPercent = Number(activeBillData.products[0].gst) || 0;
    }

    if (branchDetails?.gst_mode === "CGST/SGST") {
      const half = gstPercent / 2;
      cgst = (subtotalAfterExtraCharges * half) / 100;
      sgst = (subtotalAfterExtraCharges * half) / 100;
    } else if (branchDetails?.gst_mode === "IGST") {
      igst = (subtotalAfterExtraCharges * gstPercent) / 100;
    }

    // const finalAmount = subtotalAfterDiscounts + cgst + sgst + igst;

    const halfGst = gstPercent / 2;


    const finalAmount =
      subtotalAfterExtraCharges +
      cgst +
      sgst +
      igst;
    const totalQty = (activeBillData.products || []).reduce(
      (sum, item) => sum + (Number(item.qty || item.sale_qty) || 1),
      0
    );

    const productRows = (activeBillData.products || [])
      .map((p, index) => {
        const priceWithGST = Number(p.price) || 0;
        const itemGstPercent = Number(p.gst) || 0;
        const priceWithoutGST =
          branchDetails?.gst_type === "Inclusive"
            ? priceWithGST / (1 + itemGstPercent / 100)
            : priceWithGST;
        const total = priceWithoutGST * Number(p.qty || 0);
        return `
        <tr class="invoice-row">
          <td class="index-col">${index + 1}</td>
          <td class="item-col">${p.product_name || "-"}</td>
          <td>${p.color || "-"}</td>
          <td>${p.size_length || p.size || "-"}</td>
          <td>${p.qty || 1}</td>
          <td class="money">${priceWithoutGST.toFixed(2)}</td>
          <td class="money">${total.toFixed(2)}</td>
        </tr>
      `;
      })
      .join("");

    return `
      <style>
        @page {
          size: A4;
          margin: 15mm;
        }
        html, body {
          margin: 0;
          padding: 0;
          height: auto !important;
          min-height: 0 !important;
          font-family: Arial, sans-serif;
          color: #1f2937;
          background: #ffffff;
        }
        .invoice-print-shell {
          width: 100%;
          max-width: 100%;
          height: auto !important;
          min-height: 0 !important;
          box-sizing: border-box;
          padding: 12px 14px 24px 14px;
          background: #ffffff;
          color: #1f2937;
          font-family: Arial, sans-serif;
          font-size: 13px;
          display: block;
          overflow: visible;
        }
        .invoice-header {
          display: block;
          margin-bottom: 10px;
          page-break-inside: avoid;
        }
        .invoice-logo {
          width: 58px;
          height: 58px;
          border-radius: 50%;
          border: 2px solid #1a365d;
          background: #ffffff;
          color: #1a365d;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
        }
        .bag-icon {
          position: relative;
          width: 26px;
          height: 22px;
          border-radius: 3px;
          background: #1a365d;
          display: block;
        }
        .bag-icon::before {
          content: "";
          position: absolute;
          left: 7px;
          top: -8px;
          width: 12px;
          height: 12px;
          border: 3px solid #1a365d;
          border-bottom: 0;
          border-radius: 12px 12px 0 0;
        }
        .invoice-header h1 {
          margin: 0;
          color: #1a365d;
          font-size: 20px;
          font-weight: 900;
          letter-spacing: 0;
          line-height: 1.25;
        }
        .invoice-header p {
          margin: 4px 0 0;
          color: #555555;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.35;
        }
        .divider {
          height: 1px;
          background: #dcdcdc;
          margin: 12px 0 12px;
        }
        .info-row {
          display: flex;
          justify-content: space-between;
          gap: 18px;
          margin-bottom: 10px;
          page-break-inside: avoid;
        }
        .info-card {
          display: flex;
          align-items: center;
          gap: 12px;
          box-sizing: border-box;
          min-height: 44px;
          flex: 1 1 0;
          width: auto;
        }
        .customer-card {
          display: flex;
          align-items: center;
          gap: 12px;
          box-sizing: border-box;
          margin-bottom: 12px;
          width: 100%;
          page-break-inside: avoid;
        }
        .info-icon,
        .customer-icon {
          width: 40px;
          height: 40px;
          border: 1px solid #d8d8d8;
          border-radius: 10px;
          background: #ffffff;
          color: #666666;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 40px;
          position: relative;
        }
        .doc-icon::before {
          content: "";
          width: 16px;
          height: 20px;
          border: 2px solid #666;
          border-radius: 2px;
          box-sizing: border-box;
        }
        .doc-icon::after {
          content: "";
          position: absolute;
          width: 9px;
          height: 2px;
          background: #666;
          top: 22px;
          left: 15px;
          box-shadow: 0 -5px 0 #666;
        }
        .calendar-icon::before {
          content: "";
          width: 20px;
          height: 18px;
          border: 2px solid #666;
          border-radius: 2px;
          box-sizing: border-box;
          box-shadow: inset 0 5px 0 #666;
        }
        .person-icon::before {
          content: "";
          position: absolute;
          top: 10px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #666;
        }
        .person-icon::after {
          content: "";
          position: absolute;
          bottom: 8px;
          width: 22px;
          height: 10px;
          border-radius: 12px 12px 2px 2px;
          background: #666;
        }
        label {
          display: block;
          color: #555555;
          font-size: 16px;
          font-weight: 800;
          margin-bottom: 3px;
        }
        .info-card strong,
        .customer-card strong {
          display: block;
          color: #555555;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.25;
        }
        .info-card strong {
          font-size: 15px;
        }
        .customer-card p {
          margin: 2px 0 0;
          color: #555555;
          font-size: 14px;
          font-weight: 500;
        }
        .invoice-table {
          width: 100%;
          height: auto !important;
          border-collapse: collapse;
          border: 1px solid #dddddd;
          border-radius: 8px;
          margin: 10px 0 16px;
          table-layout: fixed;
          page-break-inside: auto;
        }
        .invoice-table thead {
          display: table-header-group;
        }
        .invoice-table tr {
          height: auto !important;
          page-break-inside: avoid;
          page-break-after: auto;
        }
        .invoice-table th {
          background: #f6f7f9;
          color: #333333;
          font-size: 13px;
          font-weight: 500;
          padding: 8px 6px;
          text-align: center;
          border-bottom: 1px solid #dddddd;
          line-height: 1.25;
        }
        .invoice-table td {
          color: #333333;
          font-size: 13px;
          font-weight: 500;
          padding: 8px 6px;
          border-bottom: 1px solid #eeeeee;
          vertical-align: middle;
          line-height: 1.25;
          word-break: break-word;
          text-align: center;
          height: auto !important;
        }
        .invoice-table tr:last-child td {
          border-bottom: 0;
        }
        .index-col {
          width: 6%;
          text-align: center !important;
        }
        .item-col {
          width: 34%;
          text-align: left !important;
        }
        .money {
          text-align: right;
        }
        .summary-box {
          width: 100%;
          height: auto !important;
          border: 1px solid #dddddd;
          border-radius: 8px;
          background: #f8f8f8;
          padding: 14px 18px;
          box-sizing: border-box;
          margin-bottom: 14px;
          page-break-inside: avoid;
        }
        .summary-row,
        .final-row {
          display: flex;
          justify-content: space-between;
          gap: 12px;
          color: #444444;
          font-size: 15px;
          font-weight: 500;
          padding: 6px 0;
        }
        .summary-row strong {
          color: #222222;
          font-weight: 500;
        }
        .divider-row {
          border-top: 1px dashed #dddddd;
          margin-top: 6px;
          padding-top: 12px;
        }
        .final-row {
          align-items: center;
          margin-top: 14px;
          padding: 18px;
          border-radius: 8px;
          background: #1a365d;
          color: #ffffff;
          font-size: 17px;
          font-weight: 900;
        }
        .final-row strong {
          color: #ffffff;
          font-size: 18px;
          font-weight: 900;
        }
        .note-box {
          margin-top: 14px;
          margin-bottom: 12px;
          padding: 12px 14px;
          background-color: #f8f9fa;
          border-radius: 8px;
          border: 1px solid #e9ecef;
          font-family: Arial, sans-serif;
          font-size: 13px;
          box-sizing: border-box;
          page-break-inside: avoid;
          break-inside: avoid;
          overflow: visible;
          height: auto !important;
        }
        .note-title {
          font-size: 10px;
          font-weight: bold;
          color: #666666;
          text-transform: uppercase;
          margin-bottom: 6px;
          letter-spacing: 0.5px;
        }
        .note-content {
          color: #333333;
          line-height: 1.5;
          font-weight: 500;
          font-size: 13px;
          white-space: pre-wrap;
          word-break: break-word;
          overflow-wrap: break-word;
        }
        .footer-divider {
          height: 1px;
          background: #dddddd;
          margin: 16px 0 10px;
          page-break-inside: avoid;
        }
        .thank-you {
          margin-top: 6px;
          text-align: center;
          color: #1a365d;
          page-break-inside: avoid;
        }
        .heart-icon {
          font-size: 18px;
          line-height: 1;
          margin-bottom: 10px;
        }
        .thank-you strong,
        .thank-you span {
          display: block;
        }
        .thank-you strong {
          font-size: 16px;
          font-weight: 500;
        }
        .thank-you span {
          margin-top: 7px;
          color: #666666;
          font-size: 13px;
          font-weight: 500;
        }
      </style>
      <div class="invoice-print-shell">
        <div class="invoice-header">
          <div class="invoice-logo"><span class="bag-icon"></span></div>
          <div>
            ${branchDetails?.bill_describe
              ? `
              <h1>${branchDetails.bill_describe.split("\n")[0].toUpperCase()}</h1>
              ${branchDetails.bill_describe
                .split("\n")
                .slice(1)
                .map(line => `<p>${line}</p>`)
                .join("")
              }
            `
              : `
              <h1>${(branchDetails?.brand_name || "COMPANY NAME").toUpperCase()}</h1>
              <p>${branchDetails?.address || ""}</p>
              <p>GST: ${branchDetails?.gst_number || "-"}</p>
            `
            }
          </div>
        </div>

        <div class="divider"></div>

        <div class="info-row">
          <div class="info-card">
            <span class="info-icon doc-icon"></span>
            <div>
              <label>Bill No.</label>
              <strong>${activeBillData.entry_no || param.entry_no || "-"}</strong>
            </div>
          </div>
          <div class="info-card">
            <span class="info-icon calendar-icon"></span>
            <div>
              <label>Date</label>
              <strong>${new Date().toLocaleDateString("en-GB")}</strong>
            </div>
          </div>
        </div>

        <div class="customer-card">
          <span class="customer-icon person-icon"></span>
          <div>
            <label>Customer</label>
            <strong>${activeBillData.customer || "-"}</strong>
            <p>Mobile: ${activeBillData.mobile || "-"}</p>
            ${param.address ? `<p>Address: ${param.address}</p>` : ""}
          </div>
        </div>

        <table class="invoice-table">
          <thead>
            <tr>
              <th class="index-col">#</th>
              <th class="item-col">Item</th>
              <th>Color</th>
              <th>Size</th>
              <th>Qty</th>
              <th>Price (₹)</th>
              <th>Total (₹)</th>
            </tr>
          </thead>
          <tbody>
            ${productRows}
            <tr class="invoice-row" style="font-weight: bold; background: #f8f9fa; border-top: 2px solid #dddddd;">
              <td class="index-col"></td>
              <td class="item-col" style="color: #1a365d;">Total</td>
              <td></td>
              <td></td>
              <td style="color: #1a365d;">${totalQty}</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <div class="summary-box">
          <div class="summary-row" style="border-bottom: 1px dashed #dddddd; padding-bottom: 6px; margin-bottom: 4px;">
            <span>Subtotal</span>
            <strong>₹${subtotal.toFixed(2)}</strong>
          </div>

          ${pointDiscount > 0 ? `<div class="summary-row"><span>Point Discount</span><strong>₹${pointDiscount.toFixed(2)}</strong></div>` : ""}

          ${voucherDiscount > 0 ? `<div class="summary-row"><span>Voucher Discount</span><strong>₹${voucherDiscount.toFixed(2)}</strong></div>` : ""}

          ${specialDiscount > 0 ? `<div class="summary-row"><span>Special Discount</span><strong>₹${specialDiscount.toFixed(2)}</strong></div>` : ""}

          ${(pointDiscount > 0 || voucherDiscount > 0 || specialDiscount > 0) ? `
            <div class="summary-row divider-row"><span>Subtotal After Discount</span><strong>₹${subtotalAfterDiscounts.toFixed(2)}</strong></div>
          ` : ""}

          ${chargeAmount > 0 ? `
            <div class="summary-row">
              <span>${extraCharge.name || "Extra Charge"}</span>
              <strong>₹${chargeAmount.toFixed(2)}</strong>
            </div>
            <div class="summary-row divider-row">
              <span>Subtotal After Extra Charge</span>
              <strong>₹${subtotalAfterExtraCharges.toFixed(2)}</strong>
            </div>
          ` : ""}

          ${branchDetails?.gst_mode === "IGST"
            ? igst === 0 ? "" : `<div class="summary-row"><span>IGST (${gstPercent.toFixed(2)}%)</span><strong>₹${igst.toFixed(2)}</strong></div>`
            : cgst === 0 && sgst === 0 ? "" : `
              <div class="summary-row"><span>CGST (${halfGst.toFixed(2)}%)</span><strong>₹${cgst.toFixed(2)}</strong></div>
              <div class="summary-row"><span>SGST (${halfGst.toFixed(2)}%)</span><strong>₹${sgst.toFixed(2)}</strong></div>
            `
          }

          <div class="final-row">
            <span>FINAL AMOUNT</span>
            <strong>₹${finalAmount.toFixed(2)}</strong>
          </div>
        </div>

        ${note ? `
          <div class="note-box">
            <div class="note-title">Notes</div>
            <div class="note-content">${note}</div>
          </div>
        ` : ""}

        <div class="footer-divider"></div>
        <div class="thank-you"></div>
      </div>
    `;
  };

  //   if (saveLoading) {
  //     return;
  //   }

  //   if (selectedProducts.length === 0) {
  //     showErrorToast("Please add products before saving.");
  //     return;
  //   }

  //   setSaveLoading(true);

  //   const payload = {
  //     ...param,
  //     customer_sale_products: selectedProducts.filter(
  //       p => Number(p.sale_qty) > 0
  //     ),
  //   };

  //   try {
  //     const dataD = await postMethod(
  //       "api/transactions/stockRetailerSales/insert",
  //       payload
  //     );

  //     const data = dataD?.data?.[0];

  //     if (data?.valid) {
  //       showSuccessToast("Saving...");


  //       // 1. Bill Upload
  //       await handleSend();

  //       // 2. Point Redeem
  //       if (redeemPoint > 0 && redeemPoint <= totalPoint) {
  //         await handlerRedeem();
  //       }

  //       // 3. Voucher Redeem
  //       if (voucherDetail?.tran_id) {
  //         await handleRedeem();
  //       }

  //       showSuccessToast("Saved successfully");

  //       history.push("/branch/retailer-sale");
  //     } else {
  //       showErrorToast(data?.error || "Save failed");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     showErrorToast("Save failed");
  //   } finally {
  //     setSaveLoading(false);
  //   }

  //   setShowBillModal(false);
  // };

  const saveData = async () => {
  if (saveLoading) {
    return;
  }

  const validProducts = selectedProducts.filter(
    (p) => Number(p.sale_qty) > 0
  );

  if (validProducts.length === 0) {
    showErrorToast("Please add products before saving.");
    return;
  }


  setStockErrors({});

  setSaveLoading(true);

  try {
    const payload = {
      ...param,
      customer_sale_products: validProducts,
    };

    const dataD = await postMethod(
      "api/transactions/stockRetailerSales/insert",
      payload
    );

    console.log("Save Response:", dataD);

    const data = dataD?.data?.[0];

    // =====================================================
    // STOCK ERROR CHECK
    // =====================================================

    if (
      dataD?.stockErrors &&
      Array.isArray(dataD.stockErrors) &&
      dataD.stockErrors.length > 0
    ) {
      const formattedErrors = {};

      dataD.stockErrors.forEach((item) => {
        formattedErrors[item.product_id] = {
          availableQty: Number(item.available_qty || 0),
          requestedQty: Number(item.requested_qty || 0),

          message:
            item.message ||
            `Available: ${item.available_qty || 0}, Requested: ${item.requested_qty || 0}`,
        };
      });

      // Product-wise error screen par show hoga
      setStockErrors(formattedErrors);

      showErrorToast(
        "Some products have insufficient stock. Please check highlighted products."
      );

  
      return;
    }

    // =====================================================
    // NORMAL ERROR
    // =====================================================

    if (!data?.valid) {
      showErrorToast(
        data?.error ||
        dataD?.error ||
        "Save failed"
      );

      return;
    }

    // =====================================================
    // SUCCESS
    // =====================================================

    console.log(
      "Generated Entry No:",
      data?.entry_no
    );

    showSuccessToast("Saving...");

    // 1. Bill Upload
    await handleSend(data.entry_no);

    // 2. Point Redeem
    if (
      Number(redeemPoint) > 0 &&
      Number(redeemPoint) <= Number(totalPoint)
    ) {
      await handlerRedeem();
    }

    // 3. Voucher Redeem
    if (voucherDetail?.tran_id) {
      await handleRedeem();
    }

    showSuccessToast("Saved successfully");

    setShowBillModal(false);

    history.push("/branch/retailer-sale");

  } catch (err) {
    console.error("Save Error:", err);

    showErrorToast(
      err?.response?.data?.error ||
      err?.message ||
      "Save failed"
    );

  } finally {
    setSaveLoading(false);
  }
};
  // ---------- bill generation ----------
  const generateBill = () => {
    const validProducts = selectedProducts.filter(
      p => Number(p.sale_qty) > 0
    );

    if (validProducts.length === 0) {
      showErrorToast("No valid products available for checkout");
      return;
    }
    if (!param.mobile || (param.mobile + "").length !== 10) {
      showErrorToast("Please enter valid mobile number before checkout.");
      return;
    }
    if (!param.customer_name || param.customer_name.trim() === "") {
      showErrorToast("Please enter valid customer or register the mobile first.");
      return;
    }
    if (selectedProducts.length === 0) {
      showErrorToast("No products selected for checkout.");
      return;
    }

    const subtotal = selectedProducts.reduce((acc, item) => acc + (Number(item.price) * Number(item.qty || 0)), 0);
    const totalItems = selectedProducts.reduce((acc, item) => acc + Number(item.qty || 0), 0);

    setBillData({
      customer: param.customer_name || "-",
      entry_no: param.entry_no,
      mobile: param.mobile || "-",
      // products: [...selectedProducts],
      products: [...validProducts],
      subtotal,
      totalItems,
      special_discount: "",
    });

    setShowBillModal(true);
  };

  const handlePrint = async () => {
    if (!billData) {
      showErrorToast("No bill data to print");
      return;
    }

    try {
      const summary = calculateBillSummary();
      if (!summary) {
        showErrorToast("Calculation error!");
        return;
      }

      const {
        subtotal,
        pointDiscount,
        voucherDiscount,
        specialDiscount,
        subtotalAfterDiscounts,
        subtotalAfterExtraCharges,
        chargeAmount,
        cgst,
        sgst,
        igst,
        finalAmount,
      } = summary;

      const gstPercent =
        billData.products && billData.products.length > 0
          ? Number(billData.products[0].gst) || 0
          : 0;
      const halfGst = gstPercent / 2;

      const totalQty = (billData.products || []).reduce(
        (sum, item) => sum + (Number(item.qty || item.sale_qty) || 1),
        0
      );

      const productRows = (billData.products || [])
        .map((p, index) => {
          const priceWithGST = Number(p.price) || 0;
          const itemGstPercent = Number(p.gst) || 0;
          const priceWithoutGST =
            branchDetails?.gst_type === "Inclusive"
              ? priceWithGST / (1 + itemGstPercent / 100)
              : priceWithGST;
          const total = priceWithoutGST * Number(p.qty || 0);
          return `
        <tr class="invoice-row">
          <td class="index-col">${index + 1}</td>
          <td class="item-col">${p.product_name || "-"}</td>
          <td>${p.color || "-"}</td>
          <td>${p.size_length || p.size || "-"}</td>
          <td>${p.qty || 1}</td>
          <td class="money">${priceWithoutGST.toFixed(2)}</td>
          <td class="money">${total.toFixed(2)}</td>
        </tr>
      `;
        })
        .join("");

      const invoiceHtml = `
      <style>
        @page {
          size: A4;
          margin: 15mm;
        }
        html, body {
          margin: 0;
          padding: 0;
          height: auto !important;
          min-height: 0 !important;
          font-family: Arial, sans-serif;
          color: #1f2937;
          background: #ffffff;
        }
        .invoice-print-shell {
          width: 100%;
          max-width: 100%;
          height: auto !important;
          min-height: 0 !important;
          box-sizing: border-box;
          padding: 12px 14px 24px 14px;
          background: #ffffff;
          color: #1f2937;
          font-family: Arial, sans-serif;
          font-size: 13px;
          display: block;
          overflow: visible;
        }
        .invoice-header {
          display: block;
          margin-bottom: 10px;
          page-break-inside: avoid;
        }
        .invoice-logo {
          width: 58px;
          height: 58px;
          border-radius: 50%;
          border: 2px solid #1a365d;
          background: #ffffff;
          color: #1a365d;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
        }
        .bag-icon {
          position: relative;
          width: 26px;
          height: 22px;
          border-radius: 3px;
          background: #1a365d;
          display: block;
        }
        .bag-icon::before {
          content: "";
          position: absolute;
          left: 7px;
          top: -8px;
          width: 12px;
          height: 12px;
          border: 3px solid #1a365d;
          border-bottom: 0;
          border-radius: 12px 12px 0 0;
        }
        .invoice-header h1 {
          margin: 0;
          color: #1a365d;
          font-size: 20px;
          font-weight: 900;
          letter-spacing: 0;
          line-height: 1.25;
        }
        .invoice-header p {
          margin: 4px 0 0;
          color: #555555;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.35;
        }
        .divider {
          height: 1px;
          background: #dcdcdc;
          margin: 12px 0 12px;
        }
        .info-row {
          display: flex;
          justify-content: space-between;
          gap: 18px;
          margin-bottom: 10px;
          page-break-inside: avoid;
        }
        .info-card {
          display: flex;
          align-items: center;
          gap: 12px;
          box-sizing: border-box;
          min-height: 44px;
          flex: 1 1 0;
          width: auto;
        }
        .customer-card {
          display: flex;
          align-items: center;
          gap: 12px;
          box-sizing: border-box;
          margin-bottom: 12px;
          width: 100%;
          page-break-inside: avoid;
        }
        .info-icon,
        .customer-icon {
          width: 40px;
          height: 40px;
          border: 1px solid #d8d8d8;
          border-radius: 10px;
          background: #ffffff;
          color: #666666;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 40px;
          position: relative;
        }
        .doc-icon::before {
          content: "";
          width: 16px;
          height: 20px;
          border: 2px solid #666;
          border-radius: 2px;
          box-sizing: border-box;
        }
        .doc-icon::after {
          content: "";
          position: absolute;
          width: 9px;
          height: 2px;
          background: #666;
          top: 22px;
          left: 15px;
          box-shadow: 0 -5px 0 #666;
        }
        .calendar-icon::before {
          content: "";
          width: 20px;
          height: 18px;
          border: 2px solid #666;
          border-radius: 2px;
          box-sizing: border-box;
          box-shadow: inset 0 5px 0 #666;
        }
        .person-icon::before {
          content: "";
          position: absolute;
          top: 10px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #666;
        }
        .person-icon::after {
          content: "";
          position: absolute;
          bottom: 8px;
          width: 22px;
          height: 10px;
          border-radius: 12px 12px 2px 2px;
          background: #666;
        }
        label {
          display: block;
          color: #555555;
          font-size: 16px;
          font-weight: 800;
          margin-bottom: 3px;
        }
        .info-card strong,
        .customer-card strong {
          display: block;
          color: #555555;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.25;
        }
        .info-card strong {
          font-size: 15px;
        }
        .customer-card p {
          margin: 2px 0 0;
          color: #555555;
          font-size: 14px;
          font-weight: 500;
        }
        .invoice-table {
          width: 100%;
          height: auto !important;
          border-collapse: collapse;
          border: 1px solid #dddddd;
          border-radius: 8px;
          margin: 10px 0 16px;
          table-layout: fixed;
          page-break-inside: auto;
        }
        .invoice-table thead {
          display: table-header-group;
        }
        .invoice-table tr {
          height: auto !important;
          page-break-inside: avoid;
          page-break-after: auto;
        }
        .invoice-table th {
          background: #f6f7f9;
          color: #333333;
          font-size: 13px;
          font-weight: 500;
          padding: 8px 6px;
          text-align: center;
          border-bottom: 1px solid #dddddd;
          line-height: 1.25;
        }
        .invoice-table td {
          color: #333333;
          font-size: 13px;
          font-weight: 500;
          padding: 8px 6px;
          border-bottom: 1px solid #eeeeee;
          vertical-align: middle;
          line-height: 1.25;
          word-break: break-word;
          text-align: center;
          height: auto !important;
        }
        .invoice-table tr:last-child td {
          border-bottom: 0;
        }
        .index-col {
          width: 6%;
          text-align: center !important;
        }
        .item-col {
          width: 34%;
          text-align: left !important;
        }
        .money {
          text-align: right;
        }
        .summary-box {
          width: 100%;
          height: auto !important;
          border: 1px solid #dddddd;
          border-radius: 8px;
          background: #f8f8f8;
          padding: 14px 18px;
          box-sizing: border-box;
          margin-bottom: 14px;
          page-break-inside: avoid;
        }
        .summary-row,
        .final-row {
          display: flex;
          justify-content: space-between;
          gap: 12px;
          color: #444444;
          font-size: 15px;
          font-weight: 500;
          padding: 6px 0;
        }
        .summary-row strong {
          color: #222222;
          font-weight: 500;
        }
        .divider-row {
          border-top: 1px dashed #dddddd;
          margin-top: 6px;
          padding-top: 12px;
        }
        .final-row {
          align-items: center;
          margin-top: 14px;
          padding: 18px;
          border-radius: 8px;
          background: #1a365d;
          color: #ffffff;
          font-size: 17px;
          font-weight: 900;
        }
        .final-row strong {
          color: #ffffff;
          font-size: 18px;
          font-weight: 900;
        }
        .note-box {
          margin-top: 14px;
          margin-bottom: 12px;
          padding: 12px 14px;
          background-color: #f8f9fa;
          border-radius: 8px;
          border: 1px solid #e9ecef;
          font-family: Arial, sans-serif;
          font-size: 13px;
          box-sizing: border-box;
          page-break-inside: avoid;
          break-inside: avoid;
          overflow: visible;
          height: auto !important;
        }
        .note-title {
          font-size: 10px;
          font-weight: bold;
          color: #666666;
          text-transform: uppercase;
          margin-bottom: 6px;
          letter-spacing: 0.5px;
        }
        .note-content {
          color: #333333;
          line-height: 1.5;
          font-weight: 500;
          font-size: 13px;
          white-space: pre-wrap;
          word-break: break-word;
          overflow-wrap: break-word;
        }
        .footer-divider {
          height: 1px;
          background: #dddddd;
          margin: 16px 0 10px;
          page-break-inside: avoid;
        }
        .thank-you {
          margin-top: 6px;
          text-align: center;
          color: #1a365d;
          page-break-inside: avoid;
        }
        .heart-icon {
          font-size: 18px;
          line-height: 1;
          margin-bottom: 10px;
        }
        .thank-you strong,
        .thank-you span {
          display: block;
        }
        .thank-you strong {
          font-size: 16px;
          font-weight: 500;
        }
        .thank-you span {
          margin-top: 7px;
          color: #666666;
          font-size: 13px;
          font-weight: 500;
        }
      </style>
      <div class="invoice-print-shell">
        <div class="invoice-header">
          <div class="invoice-logo"><span class="bag-icon"></span></div>
          <div>
            ${branchDetails?.bill_describe
              ? `
              <h1>${branchDetails.bill_describe.split("\n")[0].toUpperCase()}</h1>
              ${branchDetails.bill_describe
                .split("\n")
                .slice(1)
                .map(line => `<p>${line}</p>`)
                .join("")
              }
            `
              : `
              <h1>${(branchDetails?.brand_name || "COMPANY NAME").toUpperCase()}</h1>
              <p>${branchDetails?.address || ""}</p>
              <p>GST: ${branchDetails?.gst_number || "-"}</p>
            `
            }
          </div>
        </div>

        <div class="divider"></div>

        <div class="info-row">
          <div class="info-card">
            <span class="info-icon doc-icon"></span>
            <div>
              <label>Bill No.</label>
              <strong>${billData.entry_no || param.entry_no || "-"}</strong>
            </div>
          </div>
          <div class="info-card">
            <span class="info-icon calendar-icon"></span>
            <div>
              <label>Date</label>
              <strong>${new Date().toLocaleDateString("en-GB")}</strong>
            </div>
          </div>
        </div>

        <div class="customer-card">
          <span class="customer-icon person-icon"></span>
          <div>
            <label>Customer</label>
            <strong>${billData.customer || "-"}</strong>
            <p>Mobile: ${billData.mobile || "-"}</p>
            ${param.address ? `<p>Address: ${param.address}</p>` : ""}
          </div>
        </div>

        <table class="invoice-table">
          <thead>
            <tr>
              <th class="index-col">#</th>
              <th class="item-col">Item</th>
              <th>Color</th>
              <th>Size</th>
              <th>Qty</th>
              <th>Price (₹)</th>
              <th>Total (₹)</th>
            </tr>
          </thead>
          <tbody>
            ${productRows}
            <tr class="invoice-row" style="font-weight: bold; background: #f8f9fa; border-top: 2px solid #dddddd;">
              <td class="index-col"></td>
              <td class="item-col" style="color: #1a365d;">Total</td>
              <td></td>
              <td></td>
              <td style="color: #1a365d;">${totalQty}</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <div class="summary-box">
          <div class="summary-row" style="border-bottom: 1px dashed #dddddd; padding-bottom: 6px; margin-bottom: 4px;">
            <span>Subtotal</span>
            <strong>₹${subtotal.toFixed(2)}</strong>
          </div>

          ${pointDiscount > 0 ? `<div class="summary-row"><span>Point Discount</span><strong>₹${pointDiscount.toFixed(2)}</strong></div>` : ""}

          ${voucherDiscount > 0 ? `<div class="summary-row"><span>Voucher Discount</span><strong>₹${voucherDiscount.toFixed(2)}</strong></div>` : ""}

          ${specialDiscount > 0 ? `<div class="summary-row"><span>Special Discount</span><strong>₹${specialDiscount.toFixed(2)}</strong></div>` : ""}

          ${(pointDiscount > 0 || voucherDiscount > 0 || specialDiscount > 0) ? `
            <div class="summary-row divider-row"><span>Subtotal After Discount</span><strong>₹${subtotalAfterDiscounts.toFixed(2)}</strong></div>
          ` : ""}

          ${chargeAmount > 0 ? `
            <div class="summary-row">
              <span>${extraCharge.name || "Extra Charge"}</span>
              <strong>₹${chargeAmount.toFixed(2)}</strong>
            </div>
            <div class="summary-row divider-row">
              <span>Subtotal After Extra Charge</span>
              <strong>₹${subtotalAfterExtraCharges.toFixed(2)}</strong>
            </div>
          ` : ""}

          ${branchDetails?.gst_mode === "IGST"
            ? igst === 0 ? "" : `<div class="summary-row"><span>IGST (${gstPercent.toFixed(2)}%)</span><strong>₹${igst.toFixed(2)}</strong></div>`
            : cgst === 0 && sgst === 0 ? "" : `
              <div class="summary-row"><span>CGST (${halfGst.toFixed(2)}%)</span><strong>₹${cgst.toFixed(2)}</strong></div>
              <div class="summary-row"><span>SGST (${halfGst.toFixed(2)}%)</span><strong>₹${sgst.toFixed(2)}</strong></div>
            `
          }

          <div class="final-row">
            <span>FINAL AMOUNT</span>
            <strong>₹${finalAmount.toFixed(2)}</strong>
          </div>
        </div>

        ${note ? `
          <div class="note-box">
            <div class="note-title">Notes</div>
            <div class="note-content">${note}</div>
          </div>
        ` : ""}

        <div class="footer-divider"></div>
        <div class="thank-you"></div>
      </div>
    `;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = invoiceHtml;
      tempDiv.style.position = "fixed";
      tempDiv.style.left = "-99999px";
      tempDiv.style.top = "0";
      tempDiv.style.width = "794px";
      tempDiv.style.background = "#fff";
      document.body.appendChild(tempDiv);

      let pdfBlob;
      try {
        // const canvas = await html2canvas(tempDiv, {
        //   scale: 1,
        //   useCORS: true,
        //   backgroundColor: "#fff",
        // });
        const canvas = await html2canvas(tempDiv, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#fff",
          width: tempDiv.scrollWidth,
          height: tempDiv.scrollHeight,
          windowWidth: tempDiv.scrollWidth,
          windowHeight: tempDiv.scrollHeight
        });
        const imgData = canvas.toDataURL("image/jpeg", 0.6);
        //         const imgWidth = 100;
        //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
        //         // const pdf = new jsPDF("p", "mm", [imgWidth, imgHeight]);
        // const pdf = new jsPDF({
        //     orientation: "p",
        //     unit: "mm",
        //     format: [imgWidth, imgHeight],
        //     compress: true
        // });
        // pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        // pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
        const pxToMm = 0.264583;

        const pdfWidth = canvas.width * pxToMm;
        const pdfHeight = canvas.height * pxToMm;

        const pdf = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
          compress: true
        });

        const imgWidth = 190;
        const marginX = 10;
        const marginY = 10;
        const footerHeight = 28;
        const pageContentHeight = 297 - marginY - footerHeight; // ~259mm usable per page
        const pxPerMm = canvas.width / imgWidth;

        // Get pixel data once for smart-break scanning
        const srcCtx = canvas.getContext("2d");
        const imageData = srcCtx.getImageData(0, 0, canvas.width, canvas.height);

        const findSafeCutPx = (theoreticalPx) => {
          const searchRange = Math.round(35 * pxPerMm);
          for (let y = theoreticalPx; y > Math.max(0, theoreticalPx - searchRange); y--) {
            let isLight = true;
            const step = Math.max(1, Math.round(canvas.width / 80));
            for (let x = 0; x < canvas.width; x += step) {
              const idx = (y * canvas.width + x) * 4;
              const r = imageData.data[idx];
              const g = imageData.data[idx + 1];
              const b = imageData.data[idx + 2];
              if (r < 250 || g < 250 || b < 250) { isLight = false; break; }
            }
            if (isLight) return y;
          }
          return theoreticalPx;
        };

        let sliceStartPx = 0;
        let isFirstPage = true;

        while (sliceStartPx < canvas.height) {
          const theoreticalEndPx = sliceStartPx + Math.round(pageContentHeight * pxPerMm);
          const isLastSlice = theoreticalEndPx >= canvas.height;

          const safeCutPx = isLastSlice
            ? canvas.height
            : findSafeCutPx(Math.min(theoreticalEndPx, canvas.height));

          const sHeight = safeCutPx - sliceStartPx;
          if (sHeight <= 0) break;

          const sliceHeightMm = (sHeight * imgWidth) / canvas.width;

          const sliceCanvas = document.createElement("canvas");
          sliceCanvas.width = canvas.width;
          sliceCanvas.height = sHeight;
          const ctx = sliceCanvas.getContext("2d");
          ctx.drawImage(canvas, 0, sliceStartPx, canvas.width, sHeight, 0, 0, canvas.width, sHeight);
          const sliceData = sliceCanvas.toDataURL("image/jpeg", 0.7);

          if (!isFirstPage) pdf.addPage();

          pdf.addImage(sliceData, "JPEG", marginX, marginY, imgWidth, sliceHeightMm, undefined, "FAST");

          pdf.setFontSize(8.5);
          pdf.setTextColor(120, 120, 120);
          pdf.text(
            "Thank you for shopping with us! We appreciate your business.",
            105,
            288,
            { align: "center" }
          );

          sliceStartPx = safeCutPx;
          isFirstPage = false;
        }

        pdfBlob = pdf.output("blob");
      } finally {
        if (tempDiv.parentNode) {
          tempDiv.parentNode.removeChild(tempDiv);
        }
      }

      if (!pdfBlob || pdfBlob.size === 0) {
        showErrorToast("Failed to generate PDF!");
        return;
      }

      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
    } catch (err) {
      console.error("print pdf error", err);
      showErrorToast("Failed to open invoice PDF.");
    }
  };


  const handleSend = async (entry_no) => {
    try {

      const validProducts = selectedProducts.filter(
        p => Number(p.sale_qty) > 0
      );

      const subtotal = validProducts.reduce((acc, item) => {
        const gstPercent = Number(item.gst) || 0;
        const priceWithGST = Number(item.price) || 0;

        const priceWithoutGST =
          branchDetails?.gst_type === "Inclusive"

            ? priceWithGST / (1 + gstPercent / 100)
            : priceWithGST;

        return acc + priceWithoutGST * Number(item.qty || 0);
      }, 0);

      const totalItems = validProducts.reduce(
        (acc, item) => acc + Number(item.qty || 0),
        0
      );

      const billData = {
        customer: param.customer_name || "-",
        entry_no: entry_no,
        mobile: param.mobile || "-",
        products: validProducts,
        subtotal,
        totalItems,
        special_discount: "",
        totalDiscount: billingSummary.totalDiscount
      };

      // ✅ 1. Calculate Final Summary (Single Source of Truth)
      const summary = calculateBillSummary();
      if (!summary) {
        return showErrorToast("Calculation error!");
      }

      const {
        // subtotal,
        pointDiscount,
        voucherDiscount,
        specialDiscount,
        totalDiscount,
        subtotalAfterDiscounts,
        subtotalAfterExtraCharges,
        chargeAmount,
        cgst,
        sgst,
        igst,
        finalAmount,
      } = summary;

      const gstPercent =
        billData.products && billData.products.length > 0
          ? Number(billData.products[0].gst) || 0
          : 0;
      const halfGst = gstPercent / 2;

      const totalQty = (billData.products || []).reduce(
        (sum, item) => sum + (Number(item.qty || item.sale_qty) || 1),
        0
      );

      // ✅ 2. Generate Product Rows
      const productRows = (billData.products || [])
        .map((p, index) => {
          const priceWithGST = Number(p.price) || 0;
          const itemGstPercent = Number(p.gst) || 0;
          const priceWithoutGST =
            branchDetails?.gst_type === "Inclusive"
              ? priceWithGST / (1 + itemGstPercent / 100)
              : priceWithGST;

          const total = priceWithoutGST * Number(p.qty || 0);

          return `
          <tr class="invoice-row">
            <td class="index-col">${index + 1}</td>
            <td class="item-col">${p.product_name || "-"}</td>
            <td>${p.color || "-"}</td>
            <td>${p.size_length || p.size || "-"}</td>
            <td>${p.qty || 1}</td>
            <td class="money">${priceWithoutGST.toFixed(2)}</td>
            <td class="money">${total.toFixed(2)}</td>
          </tr>
        `;
        })
        .join("");

      // ✅ 3. Build Styled Invoice HTML
      const htmlContent = `
  <style>
    @page {
      size: A4;
      margin: 15mm;
    }
    html, body {
      margin: 0;
      padding: 0;
      height: auto !important;
      min-height: 0 !important;
      font-family: Arial, sans-serif;
      color: #1f2937;
      background: #ffffff;
    }
    .invoice-print-shell {
      width: 100%;
      max-width: 100%;
      height: auto !important;
      min-height: 0 !important;
      box-sizing: border-box;
      padding: 12px 14px 24px 14px;
      background: #ffffff;
      color: #1f2937;
      font-family: Arial, sans-serif;
      font-size: 13px;
      display: block;
      overflow: visible;
    }
    .invoice-header {
      display: block;
      margin-bottom: 10px;
      page-break-inside: avoid;
    }
    .invoice-logo {
      width: 58px;
      height: 58px;
      border-radius: 50%;
      border: 2px solid #1a365d;
      background: #ffffff;
      color: #1a365d;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
    }
    .bag-icon {
      position: relative;
      width: 26px;
      height: 22px;
      border-radius: 3px;
      background: #1a365d;
      display: block;
    }
    .bag-icon::before {
      content: "";
      position: absolute;
      left: 7px;
      top: -8px;
      width: 12px;
      height: 12px;
      border: 3px solid #1a365d;
      border-bottom: 0;
      border-radius: 12px 12px 0 0;
    }
    .invoice-header h1 {
      margin: 0;
      color: #1a365d;
      font-size: 20px;
      font-weight: 900;
      letter-spacing: 0;
      line-height: 1.25;
    }
    .invoice-header p {
      margin: 4px 0 0;
      color: #555555;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.35;
    }
    .divider {
      height: 1px;
      background: #dcdcdc;
      margin: 12px 0 12px;
    }
    .info-row {
      display: flex;
      justify-content: space-between;
      gap: 18px;
      margin-bottom: 10px;
      page-break-inside: avoid;
    }
    .info-card {
      display: flex;
      align-items: center;
      gap: 12px;
      box-sizing: border-box;
      min-height: 44px;
      flex: 1 1 0;
      width: auto;
    }
    .customer-card {
      display: flex;
      align-items: center;
      gap: 12px;
      box-sizing: border-box;
      margin-bottom: 12px;
      width: 100%;
      page-break-inside: avoid;
    }
    .info-icon,
    .customer-icon {
      width: 40px;
      height: 40px;
      border: 1px solid #d8d8d8;
      border-radius: 10px;
      background: #ffffff;
      color: #666666;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 40px;
      position: relative;
    }
    .doc-icon::before {
      content: "";
      width: 16px;
      height: 20px;
      border: 2px solid #666;
      border-radius: 2px;
      box-sizing: border-box;
    }
    .doc-icon::after {
      content: "";
      position: absolute;
      width: 9px;
      height: 2px;
      background: #666;
      top: 22px;
      left: 15px;
      box-shadow: 0 -5px 0 #666;
    }
    .calendar-icon::before {
      content: "";
      width: 20px;
      height: 18px;
      border: 2px solid #666;
      border-radius: 2px;
      box-sizing: border-box;
      box-shadow: inset 0 5px 0 #666;
    }
    .person-icon::before {
      content: "";
      position: absolute;
      top: 10px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #666;
    }
    .person-icon::after {
      content: "";
      position: absolute;
      bottom: 8px;
      width: 22px;
      height: 10px;
      border-radius: 12px 12px 2px 2px;
      background: #666;
    }
    label {
      display: block;
      color: #555555;
      font-size: 16px;
      font-weight: 800;
      margin-bottom: 3px;
    }
    .info-card strong,
    .customer-card strong {
      display: block;
      color: #555555;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.25;
    }
    .info-card strong {
      font-size: 15px;
    }
    .customer-card p {
      margin: 2px 0 0;
      color: #555555;
      font-size: 14px;
      font-weight: 500;
    }
    .invoice-table {
      width: 100%;
      height: auto !important;
      border-collapse: collapse;
      border: 1px solid #dddddd;
      border-radius: 8px;
      margin: 10px 0 16px;
      table-layout: fixed;
      page-break-inside: auto;
    }
    .invoice-table thead {
      display: table-header-group;
    }
    .invoice-table tr {
      height: auto !important;
      page-break-inside: avoid;
      page-break-after: auto;
    }
    .invoice-table th {
      background: #f6f7f9;
      color: #333333;
      font-size: 13px;
      font-weight: 500;
      padding: 8px 6px;
      text-align: center;
      border-bottom: 1px solid #dddddd;
      line-height: 1.25;
    }
    .invoice-table td {
      color: #333333;
      font-size: 13px;
      font-weight: 500;
      padding: 8px 6px;
      border-bottom: 1px solid #eeeeee;
      vertical-align: middle;
      line-height: 1.25;
      word-break: break-word;
      text-align: center;
      height: auto !important;
    }
    .invoice-table tr:last-child td {
      border-bottom: 0;
    }
    .index-col {
      width: 6%;
      text-align: center !important;
    }
    .item-col {
      width: 34%;
      text-align: left !important;
    }
    .money {
      text-align: right;
    }
    .summary-box {
      width: 100%;
      height: auto !important;
      border: 1px solid #dddddd;
      border-radius: 8px;
      background: #f8f8f8;
      padding: 14px 18px;
      box-sizing: border-box;
      margin-bottom: 14px;
      page-break-inside: avoid;
    }
    .summary-row,
    .final-row {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      color: #444444;
      font-size: 15px;
      font-weight: 500;
      padding: 6px 0;
    }
    .summary-row strong {
      color: #222222;
      font-weight: 500;
    }
    .divider-row {
      border-top: 1px dashed #dddddd;
      margin-top: 6px;
      padding-top: 12px;
    }
    .final-row {
      align-items: center;
      margin-top: 14px;
      padding: 18px;
      border-radius: 8px;
      background: #1a365d;
      color: #ffffff;
      font-size: 17px;
      font-weight: 900;
    }
    .final-row strong {
      color: #ffffff;
      font-size: 18px;
      font-weight: 900;
    }
    .note-box {
      margin-top: 14px;
      margin-bottom: 12px;
      padding: 12px 14px;
      background-color: #f8f9fa;
      border-radius: 8px;
      border: 1px solid #e9ecef;
      font-family: Arial, sans-serif;
      font-size: 13px;
      box-sizing: border-box;
      page-break-inside: avoid;
      break-inside: avoid;
      overflow: visible;
      height: auto !important;
    }
    .note-title {
      font-size: 10px;
      font-weight: bold;
      color: #666666;
      text-transform: uppercase;
      margin-bottom: 6px;
      letter-spacing: 0.5px;
    }
    .note-content {
      color: #333333;
      line-height: 1.5;
      font-weight: 500;
      font-size: 13px;
      white-space: pre-wrap;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    .footer-divider {
      height: 1px;
      background: #dddddd;
      margin: 16px 0 10px;
      page-break-inside: avoid;
    }
    .thank-you {
      margin-top: 6px;
      text-align: center;
      color: #1a365d;
      page-break-inside: avoid;
    }
    .heart-icon {
      font-size: 18px;
      line-height: 1;
      margin-bottom: 10px;
    }
    .thank-you strong,
    .thank-you span {
      display: block;
    }
    .thank-you strong {
      font-size: 16px;
      font-weight: 500;
    }
    .thank-you span {
      margin-top: 7px;
      color: #666666;
      font-size: 13px;
      font-weight: 500;
    }
  </style>

  <div class="invoice-print-shell">

    <div class="invoice-header">
      <div class="invoice-logo"><span class="bag-icon"></span></div>
      <div>
        ${branchDetails?.bill_describe
          ? `
        <h1>${branchDetails.bill_describe.split("\n")[0].toUpperCase()}</h1>
        ${branchDetails.bill_describe
            .split("\n")
            .slice(1)
            .map(line => `<p>${line}</p>`)
            .join("")
          }
      `
          : `
        <h1>${(branchDetails?.brand_name || "COMPANY NAME").toUpperCase()}</h1>
        <p>${branchDetails?.address || ""}</p>
        <p>GST: ${branchDetails?.gst_number || "-"}</p>
      `
        }
      </div>
    </div>

    <div class="divider"></div>

    <div class="info-row">
      <div class="info-card">
        <span class="info-icon doc-icon"></span>
        <div>
          <label>Bill No.</label>
          <strong>${entry_no || "-"}</strong>
        </div>
      </div>
      <div class="info-card">
        <span class="info-icon calendar-icon"></span>
        <div>
          <label>Date</label>
          <strong>${new Date().toLocaleDateString("en-GB")}</strong>
        </div>
      </div>
    </div>

    <div class="customer-card">
      <span class="customer-icon person-icon"></span>
      <div>
        <label>Customer</label>
        <strong>${billData.customer || "-"}</strong>
        <p>Mobile: ${billData.mobile || "-"}</p>
        ${param.address ? `<p>Address: ${param.address}</p>` : ""}
      </div>
    </div>

    <table class="invoice-table">
      <thead>
        <tr>
          <th class="index-col">#</th>
          <th class="item-col">Item</th>
          <th>Color</th>
          <th>Size</th>
          <th>Qty</th>
          <th>Price (₹)</th>
          <th>Total (₹)</th>
        </tr>
      </thead>
      <tbody>
        ${productRows}
        <tr class="invoice-row" style="font-weight: bold; background: #f8f9fa; border-top: 2px solid #dddddd;">
          <td class="index-col"></td>
          <td class="item-col" style="color: #1a365d;">Total</td>
          <td></td>
          <td></td>
          <td style="color: #1a365d;">${totalQty}</td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>

    <div class="summary-box">

      <div class="summary-row" style="border-bottom: 1px dashed #dddddd; padding-bottom: 6px; margin-bottom: 4px;">
        <span>Subtotal</span>
        <strong>₹${subtotal.toFixed(2)}</strong>
      </div>

      ${pointDiscount > 0 ? `<div class="summary-row"><span>Point Discount</span><strong>₹${pointDiscount.toFixed(2)}</strong></div>` : ""}

      ${voucherDiscount > 0 ? `<div class="summary-row"><span>Voucher Discount</span><strong>₹${voucherDiscount.toFixed(2)}</strong></div>` : ""}

      ${specialDiscount > 0 ? `<div class="summary-row"><span>Special Discount</span><strong>₹${specialDiscount.toFixed(2)}</strong></div>` : ""}
      ${(pointDiscount > 0 || voucherDiscount > 0 || specialDiscount > 0) ? `
        <div class="summary-row divider-row"><span>Subtotal After Discount</span><strong>₹${subtotalAfterDiscounts.toFixed(2)}</strong></div>
      ` : ""}
      ${chargeAmount > 0 ? `
        <div class="summary-row">
          <span>${extraCharge.name || "Extra Charge"}</span>
          <strong>₹${chargeAmount.toFixed(2)}</strong>
        </div>
        <div class="summary-row divider-row">
          <span>Subtotal After Extra Charge</span>
          <strong>₹${subtotalAfterExtraCharges.toFixed(2)}</strong>
        </div>
      ` : ""}
      ${branchDetails?.gst_mode === "IGST"
          ? igst === 0 ? "" : `<div class="summary-row"><span>IGST (${gstPercent.toFixed(2)}%)</span><strong>₹${igst.toFixed(2)}</strong></div>`
          : cgst === 0 && sgst === 0 ? "" : `
          <div class="summary-row"><span>CGST (${halfGst.toFixed(2)}%)</span><strong>₹${cgst.toFixed(2)}</strong></div>
          <div class="summary-row"><span>SGST (${halfGst.toFixed(2)}%)</span><strong>₹${sgst.toFixed(2)}</strong></div>
        `
        }

      <div class="final-row">
        <span>FINAL AMOUNT</span>
        <strong>₹${finalAmount.toFixed(2)}</strong>
      </div>

    </div>

    ${note ? `
      <div class="note-box">
        <div class="note-title">Notes</div>
        <div class="note-content">${note}</div>
      </div>
    ` : ""}
    
    <div class="footer-divider"></div>
    <div class="thank-you"></div>
  </div>
`;
      // ✅ 5. Convert HTML to Canvas
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      tempDiv.style.position = "fixed";
      tempDiv.style.left = "-99999px";
      tempDiv.style.top = "0";
      tempDiv.style.width = "794px";
      tempDiv.style.background = "#fff";
      document.body.appendChild(tempDiv);

      let pdfBlob;

      try {
        //     const canvas = await html2canvas(tempDiv, {
        //   scale: 3,
        //   useCORS: true,
        //   backgroundColor: "#ffffff",
        //   width: 794,
        //   height: 1123
        // });

        // const canvas = await html2canvas(tempDiv, {
        //   scale: 1, // 3 se slow hota hai
        //   useCORS: true,
        //   backgroundColor: "#fff",
        // });
        const canvas = await html2canvas(tempDiv, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#fff",
          width: tempDiv.scrollWidth,
          height: tempDiv.scrollHeight,
          windowWidth: tempDiv.scrollWidth,
          windowHeight: tempDiv.scrollHeight
        });
        const imgData = canvas.toDataURL("image/jpeg", 0.6);
        // const imgData = canvas.toDataURL("image/png");
        //         const imgData = canvas.toDataURL("image/jpeg", 0.6); // quality 0.6

        //         const imgWidth = 100;
        //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
        //         // const pdf = new jsPDF("p", "mm", [imgWidth, imgHeight]);
        //         const pdf = new jsPDF({
        //     orientation: "p",
        //     unit: "mm",
        //     format: [imgWidth, imgHeight],
        //     compress: true
        // });

        // pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        // pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
        const pxToMm = 0.264583;

        const pdfWidth = canvas.width * pxToMm;
        const pdfHeight = canvas.height * pxToMm;

        const pdf = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
          compress: true
        });

        const imgWidth = 190;
        const marginX = 10;
        const marginY = 10;
        const footerHeight = 28;
        const pageContentHeight = 297 - marginY - footerHeight; // ~259mm usable per page
        const pxPerMm = canvas.width / imgWidth;

        // Get pixel data once for smart-break scanning
        const srcCtx = canvas.getContext("2d");
        const imageData = srcCtx.getImageData(0, 0, canvas.width, canvas.height);

        const findSafeCutPx = (theoreticalPx) => {
          const searchRange = Math.round(35 * pxPerMm);
          for (let y = theoreticalPx; y > Math.max(0, theoreticalPx - searchRange); y--) {
            let isLight = true;
            const step = Math.max(1, Math.round(canvas.width / 80));
            for (let x = 0; x < canvas.width; x += step) {
              const idx = (y * canvas.width + x) * 4;
              const r = imageData.data[idx];
              const g = imageData.data[idx + 1];
              const b = imageData.data[idx + 2];
              if (r < 250 || g < 250 || b < 250) { isLight = false; break; }
            }
            if (isLight) return y;
          }
          return theoreticalPx;
        };

        let sliceStartPx = 0;
        let isFirstPage = true;

        while (sliceStartPx < canvas.height) {
          const theoreticalEndPx = sliceStartPx + Math.round(pageContentHeight * pxPerMm);
          const isLastSlice = theoreticalEndPx >= canvas.height;

          const safeCutPx = isLastSlice
            ? canvas.height
            : findSafeCutPx(Math.min(theoreticalEndPx, canvas.height));

          const sHeight = safeCutPx - sliceStartPx;
          if (sHeight <= 0) break;

          const sliceHeightMm = (sHeight * imgWidth) / canvas.width;

          const sliceCanvas = document.createElement("canvas");
          sliceCanvas.width = canvas.width;
          sliceCanvas.height = sHeight;
          const ctx = sliceCanvas.getContext("2d");
          ctx.drawImage(canvas, 0, sliceStartPx, canvas.width, sHeight, 0, 0, canvas.width, sHeight);
          const sliceData = sliceCanvas.toDataURL("image/jpeg", 0.7);

          if (!isFirstPage) pdf.addPage();

          pdf.addImage(sliceData, "JPEG", marginX, marginY, imgWidth, sliceHeightMm, undefined, "FAST");

          pdf.setFontSize(8.5);
          pdf.setTextColor(120, 120, 120);
          pdf.text(
            "Thank you for shopping with us! We appreciate your business.",
            105,
            288,
            { align: "center" }
          );

          sliceStartPx = safeCutPx;
          isFirstPage = false;
        }

        pdfBlob = pdf.output("blob");
      } finally {
        if (tempDiv.parentNode) {
          tempDiv.parentNode.removeChild(tempDiv);
        }
      }

      if (!pdfBlob || pdfBlob.size === 0) {
        return showErrorToast("Failed to generate PDF!");
      }

      // ✅ 7. Upload to Server
      const formData = new FormData();

      formData.append("file", pdfBlob, "bill.pdf");

      // ✅ ADD HTML ALSO
      formData.append("invoice_html", htmlContent);

      formData.append("customer_name", billData.customer || "");
      formData.append("mobile", billData.mobile || "");
      formData.append("branch", localStorage.getItem("jwl_branch_id") || "");
      formData.append("entry_no", entry_no || "");
      formData.append("redeemPoint", redeemPoint || 0);
      formData.append("voucher_id", voucherDetail?.voucher_id || "");
      formData.append("voucher_name", voucherDetail?.voucher_name || "");
      formData.append("special_discount", billData.special_discount || "");
      formData.append(
        "totalDiscount",
        totalDiscount.toFixed(2)
      );
      formData.append("IGST", igst.toFixed(2));
      formData.append("CGST", cgst.toFixed(2));
      formData.append("SGST", sgst.toFixed(2));
      formData.append(
        "subtotal_after_discount",
        subtotalAfterDiscounts.toFixed(2)
      );
      formData.append("final_amount", finalAmount.toFixed(2));
      formData.append("customer_id", param.customer_id);
      formData.append("staff_id", param.staff_id);
      formData.append("extra_charge_name", extraCharge.name || "Extra Charge");
      formData.append("extra_charge_amount", extraCharge.amount || 0);
      formData.append("note", note || "");

      const token = localStorage.getItem("jwl_token");

      const response = await fetch(
        API_BASE_URL + "api/transactions/customer/uploadBill",
        {
          method: "POST",
          headers: {
            "auth-token": token,
          },
          body: formData,
        }
      );

      if (response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
        return;
      }

      const result = await response.json();

      if (result.success) {
        showSuccessToast("Bill uploaded successfully!");
        console.log("Uploaded Path:", result.filePath);
      } else {
        showErrorToast(result.error || "Upload failed!");
      }

      setShowBillModal(false);

    } catch (err) {
      console.error("Error in handleSend:", err);
      showErrorToast("Something went wrong!");
    }
  };



  // remove selected product
  const removeProduct = (product_id) => {
    setSelectedProducts((prev) => prev.filter((p) => p.product_id !== product_id));
  };

  // delete a product row from productlist
  const deleteRow = (id) => {
    setProductlist((prev) => prev.filter((item) => item.product_id !== id));
    setSelectedProducts((prev) => prev.filter((item) => item.product_id !== id));
  };

  // customer points & vouchers
  const handleCustomerPointList = (customer_id) => {
    postMethod("api/customervisit/getCustomerPointList", { customer_id })
      .then((data) => {
        const d = data.data || [];
        setCustomerPointList(d);
        if (d && d[0] && d[0].total_points) setTotalPoint(d[0].total_points);
      })
      .catch((e) => console.error("pointlist error", e));
  };

  const handleCustomerVoucherList = (customer_id) => {
    postMethod("api/customervisit/getCustomerVoucherList", { customer_id })
      .then((d) => {
        const arr = d.data || [];
        setCustomerVoucherList(arr);
        if (arr && arr[0] && arr[0].voucher_count) setVoucherCount(arr[0].voucher_count);
      })
      .catch((e) => console.error("voucher list error", e));
  };

  const handleRedeemChange = (e) => {
    const val = e.target.value;

    if (!/^\d*$/.test(val)) return;

    if (Number(val) > Number(totalPoint)) {
      setErrorMsg(`Redeem point cannot exceed ${totalPoint}.`);
      return; // stop typing beyond limit
    }

    setErrorMsg("");
    setRedeemPoint(val);
    setRedeemPointData({ ...redeemPointData, redeemPoint: val });
    setBillingSummary((prev) => ({
      ...prev,
      redeemPoint: Number(val) || 0,
    }));
  };

  // computed totals for UI
  const totalItemsCount = useMemo(() => selectedProducts.reduce((acc, it) => acc + Number(it.qty || 0), 0), [selectedProducts]);
  const subtotalAmount = useMemo(() => selectedProducts.reduce((acc, it) => acc + (Number(it.price || 0) * Number(it.qty || 0)), 0), [selectedProducts]);

  // ---------------- UI ----------------

  // -----------------point Voucher Redeem----------------
  const [redeemPointData, setRedeemPointData] = useState({
    customer_id: param.customer_id,
    mobile: param.mobile,
    full_name: param.customer_name,
    redeemPoint: "",
    remark: " Point redeem from retailer",
    staff_id: param.staff_id,
    branch_id: localStorage.getItem("jwl_branch_id")
  });
  const [success, setSuccess] = useState(false);

  function handlerRedeem() {
    if (redeemPoint > totalPoint || redeemPoint == null) {
      alert("Invalid Points");
    } else {
      // alert(JSON.stringify(redeemPointData))
      postMethod("api/customervisit/insertPointRedeem02", redeemPointData).then(
        (data) => {
          if (data.data[0].valid) {
            setSuccess(true);
            setTimeout(() => {
              window.location.reload(); // Reloads the current page
            }, 2000);
          }
        }
      );
    }
  }

  // -Voucher Redeem

  const [redeemVoucherData, setRedeemVoucherData] = useState({
    tran_id: voucherDetail.tran_id,
    Customer_id: param.customer_id,
    voucher_id: voucherDetail.voucher_id,
  });

  const handleRedeem = (tran_id, customer_id, voucher_id) => {
    postMethod("api/customervisit/insertVoucherRedeem", redeemVoucherData).then(
      (data) => {
        if (data.data[0].valid) {
          console.log("Voucher redeem succesfully");
        }
      }
    );

  };


  // -----------------

  const calculateBillSummary = () => {
    if (!billData?.products) return null;

    const subtotal = billData.products.reduce((acc, p) => {
      const gstPercent = Number(p.gst) || 0;
      const priceWithGST = Number(p.price) || 0;
      const priceWithoutGST =
        branchDetails?.gst_type === "Inclusive"
          ? priceWithGST / (1 + gstPercent / 100)
          : priceWithGST;

      return acc + priceWithoutGST * Number(p.qty || 0);
    }, 0);

    // 🎯 Point Discount
    const pointPerRs = Number(branchDetails?.rupees_per_point) || 0;
    const pointDiscountRaw =
      redeemPoint ? (pointPerRs > 0 ? Number(redeemPoint) / pointPerRs : Number(redeemPoint)) : 0;

    // 🎟 Voucher Discount
    let voucherDiscountRaw = 0;
    const voucherAmt = voucherDetail?.amount || "";

    if (voucherAmt.includes("%")) {
      const percent = parseFloat(voucherAmt);
      voucherDiscountRaw = (subtotal * percent) / 100;
    } else {
      voucherDiscountRaw = parseFloat(voucherAmt.replace(/[^0-9.]/g, "")) || 0;
    }

    // ✳️ Special Discount
    const sp = billData.special_discount || "";
    const isPercent = sp.includes("%");
    const specialDiscountRaw = isPercent
      ? (subtotal * parseFloat(sp)) / 100
      : parseFloat(sp || 0);
    const chargeAmountRaw = Number(extraCharge.amount || 0);
    let pointDiscount = pointDiscountRaw;
    let voucherDiscount = voucherDiscountRaw;
    let specialDiscount = specialDiscountRaw;
    let chargeAmount = chargeAmountRaw;

    if (branchDetails?.gst_type === "Inclusive") {
      const gstPercent =
        billData.products?.length > 0
          ? Number(billData.products[0].gst || 0)
          : 0;

      const divisor = 1 + gstPercent / 100;

      pointDiscount = pointDiscountRaw / divisor;
      voucherDiscount = voucherDiscountRaw / divisor;
      specialDiscount = specialDiscountRaw / divisor;
      chargeAmount = chargeAmountRaw / divisor;
    }

    // Discount which will be saved to API
    let totalDiscount = 0;

    if (branchDetails?.gst_type === "Inclusive") {
      // User ko GST inclusive discount dikhana hai
      totalDiscount =
        pointDiscountRaw +
        voucherDiscountRaw +
        specialDiscountRaw;
    } else {
      // GST Exclusive
      totalDiscount =
        pointDiscount +
        voucherDiscount +
        specialDiscount;
    }

    const subtotalAfterDiscounts = Math.max(
      subtotal - (pointDiscount + voucherDiscount + specialDiscount),
      0
    );

    const subtotalAfterExtraCharges =
      subtotalAfterDiscounts + chargeAmount;

    // 💰 GST
    let cgst = 0,
      sgst = 0,
      igst = 0,
      gstPercent = 0;

    if (billData.products.length > 0) {
      gstPercent = Number(billData.products[0].gst) || 0;
    }

    if (branchDetails?.gst_mode === "CGST/SGST") {
      const half = gstPercent / 2;
      cgst = (subtotalAfterExtraCharges * half) / 100;
      sgst = (subtotalAfterExtraCharges * half) / 100;
    } else if (branchDetails?.gst_mode === "IGST") {
      igst = (subtotalAfterExtraCharges * gstPercent) / 100;
    }



    const finalAmount =
      subtotalAfterExtraCharges +
      cgst +
      sgst +
      igst;

    return {
      subtotal,
      pointDiscount,
      voucherDiscount,
      specialDiscount,
      totalDiscount,
      subtotalAfterDiscounts,
      subtotalAfterExtraCharges,
      chargeAmount,
      cgst,
      sgst,
      igst,
      finalAmount,
    };
  };


  useEffect(() => {
    const summary = calculateBillSummary();
    if (!summary) return;

    setBillingSummary({
      redeemPoint: Number(redeemPoint) || 0,
      voucher_id: voucherDetail?.voucher_id || "",
      voucher_name: voucherDetail?.voucher_name || "",
      special_discount: billData?.special_discount || "",
      totalDiscount: summary.totalDiscount.toFixed(2),
      IGST: summary.igst.toFixed(2),
      CGST: summary.cgst.toFixed(2),
      SGST: summary.sgst.toFixed(2),
      subtotal_after_discount: summary.subtotalAfterDiscounts.toFixed(2),
      final_amount: summary.finalAmount.toFixed(2),
    });
  }, [billData, branchDetails, redeemPoint, voucherDetail]);



  // -------------------------------------------------------
  return (
    <>
      {loading && <Loader />}

      <div className="retailer-sales-editor-form">
        <div className="retailer-sales-editor-card">
          <Row className="retailer-sales-editor-header">
            <Col sm={12}>
              <div className="retailer-sales-editor-title">
                <span className="retailer-sales-editor-icon">
                  <i className="fas fa-cash-register" />
                </span>
                <div>
                  <h4>Add Customer Sales</h4>
                  <p>Create a retailer sale, adjust quantities, and checkout.</p>
                </div>
              </div>
            </Col>
          </Row>

          <div className="retailer-sales-editor-body">
            <Row className="retailer-sales-editor-grid">
              <Col sm={4}>
                <FormGroup>
                  <Label>Title</Label>
                  <Input
                    value={param.title}
                    onChange={(e) => setParam((p) => ({ ...p, title: e.target.value }))}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Entry No.</Label>
                  <Input value={param.entry_no} disabled />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Mobile</Label>
                  <Input
                    type="tel"
                    value={param.mobile}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // only digits
                      if (value.length <= 10) {
                        checkMobile(value);
                      }
                    }}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Customer Name</Label>
                  <Input value={param.customer_name}
                    onChange={(e) => setParam({ ...param, customer_name: e.target.value })}

                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>Staff Name</Label>
                  <select
                    className="form-control h-auto py-2 px-6"
                    onChange={(e) =>
                      setParam({ ...param, staff_id: e.target.value })
                    }
                    name="staff_id"
                    value={param.staff_id}

                  >
                    <option value="">--Select--</option>
                    {staffList.map((prop, i) => (
                      <option key={i} value={prop.staff_id}>
                        {prop.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
              </Col>
              <Col sm={4}>
                <div className="retailer-sales-editor-remark retailer-sales-editor-remarks-inline">
                  <FormGroup>
                    <Label>Remarks</Label>
                    <Input type="textarea" value={param.remarks} onChange={(e) => setParam((p) => ({ ...p, remarks: e.target.value }))} />
                  </FormGroup>
                </div></Col>

            </Row>
            {/* --------------------------------new Search and table------------------------------------ */}
            {/* New Search Product Section */}

            <Row className="customer-sales-editor-section">

              <Col sm={12} md={5}>
                <div className="customer-sales-editor-section-title">
                  <span>
                    <i className="fas fa-search" />
                  </span>
                  <div>
                    <h4>Searched Products</h4>
                    <p>Search by product code and choose items for this sale.</p>
                  </div>
                </div>
              </Col>


              {/* ----------- */}

              <Col sm={12} md={7}>
                <FormGroup className="d-flex">

                  <Input
                    value={searchProduct}
                    placeholder="Search Product"
                    onChange={(e) =>
                      setSearchProduct(e.target.value)
                    }
                  />

                  <Button
                    color="success"
                    className="btn btn-success customer-sales-editor-inline-btn"
                    onClick={searchProductsForSelection}
                  >
                    {searchProductsLoading
                      ? "Searching..."
                      : "Search"}
                  </Button>

                </FormGroup>
              </Col>

              <Col sm={12}>

                <Table bordered responsive>

                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Name</th>
                      <th>Gender</th>
                      <th>Color</th>
                      <th>Size</th>
                      <th>Price</th>
                      <th>Stock</th>
                      <th>Qty</th>
                      <th>Image</th>
                      <th>Add</th>
                    </tr>
                  </thead>

                  <tbody>

                    {searchProductsList.length > 0 ? (

                      searchProductsList.map((obj, i) => {
                        const hasStockError = Boolean(stockErrors[obj.product_id]);
                        return (
                          <tr
                            key={obj.product_id}
                            style={
                              hasStockError
                                ? {
                                    backgroundColor: "#ffebee",
                                    borderLeft: "4px solid #d32f2f",
                                  }
                                : {}
                            }
                          >

                          <td>{obj.product_code}</td>

                          <td>{obj.product_name}</td>

                          <td>{obj.gender}</td>

                          <td>{obj.color}</td>

                          <td>{obj.size_length}</td>

                          <td>{obj.price}</td>

                          <td>{obj.qty}</td>

                          <td>

                            <Input
                              type="number"
                              min="1"
                              value={obj.sale_qty}
                              onFocus={() => {
                                if (obj.sale_qty === 1) {
                                  const temp = [...searchProductsList];
                                  temp[i].sale_qty = "";
                                  setSearchProductsList(temp);
                                }
                              }}
                              onBlur={(e) => {
                                if (e.target.value === "") {
                                  const temp = [...searchProductsList];
                                  temp[i].sale_qty = 1;
                                  setSearchProductsList(temp);
                                }
                              }}
                              onChange={(e) =>
                                handleSearchQtyChange(
                                  e.target.value,
                                  i,
                                  obj
                                )
                              }
                            />

                          </td>

                          <td>

                            <img
                              src={
                                obj.isImageUrl
                                  ? obj.image_path
                                  : obj.url_image +
                                  obj.image_path
                              }
                              width="50"
                              alt=""
                            />

                          </td>

                          <td>
                            <input
                              type="checkbox"
                              className="big-checkbox"
                              checked={
                                selectedProducts.findIndex(
                                  x => x.product_id === obj.product_id
                                ) > -1
                              }
                              onChange={(e) =>
                                handleSearchProductSelect(
                                  e.target.checked,
                                  obj
                                )
                              }
                            />
                          </td>
                        </tr>
                        );
                      })

                    ) : (

                      <tr>
                        <td colSpan="10" className="text-center">
                          No Data
                        </td>
                      </tr>

                    )}

                  </tbody>

                </Table>

              </Col>

            </Row>


            {/* ------------------------------------end----------------------------------------------- */}

            <Row className="retailer-sales-editor-content">
              <Col sm={8}>
                <FormGroup className="retailer-sales-editor-search">
                  <Input
                    placeholder="Search by product code or name"
                    value={searchProduct}
                    onChange={(e) => setSearchProduct(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        searchProductFun();     // search function call
                        setSearchProduct("");  // input clear
                      }
                    }}
                  />
                  <Button color="success" className="ms-2" onClick={searchProductFun} disabled={searchLoading}>
                    {searchLoading ? "Searching..." : "Search"}
                  </Button>
                </FormGroup>
                <div className="retailer-sales-editor-table-wrap">
                  <Table bordered className="retailer-sales-editor-product-table">
                    <tbody>
                      {productlist && productlist.length > 0 ? (
                        productlist
                          .filter(obj => Number(obj.sale_qty || 0) > 0)
                          .map((obj, i) => {
                            const hasStockError = Boolean(stockErrors[obj.product_id]);
                            const errorInfo = stockErrors[obj.product_id];

                            return (
                              <tr
                                key={obj.product_id || i}
                                style={
                                  hasStockError
                                    ? {
                                        backgroundColor: "#ffebee",
                                        borderLeft: "4px solid #d32f2f",
                                      }
                                    : {}
                                }
                              >
                                <td>
                                  <div className="retailer-sales-editor-product-name">
                                    <strong style={hasStockError ? { color: "#d32f2f" } : {}}>
                                      {obj.product_name}
                                    </strong>{" "}
                                    <small style={{ color: hasStockError ? "#d32f2f" : "#888" }}>
                                      ({obj.stock_qty})
                                    </small>
                                  </div>
                                  <div className="retailer-sales-editor-product-code">{obj.product_code}</div>
                                  <div className="retailer-sales-editor-product-meta">{obj.gender} <small style={{ color: "#888" }}>({obj.size_length})</small></div>
                                  {hasStockError && (
                                    <div
                                      style={{
                                        color: "#d32f2f",
                                        fontSize: "11px",
                                        fontWeight: "bold",
                                        marginTop: "2px",
                                      }}
                                    >
                                      ⚠ {errorInfo?.message || "Insufficient stock"}
                                    </div>
                                  )}
                                </td>
                                <td style={{ width: 100 }}><b style={hasStockError ? { color: "#d32f2f" } : {}}>{obj.price}</b></td>
                                <td style={{ width: 70 }}>
                                  <Input
                                    value={obj.sale_qty}
                                    type="number"
                                    readOnly
                                    style={
                                      hasStockError
                                        ? {
                                            borderColor: "#d32f2f",
                                            color: "#d32f2f",
                                            fontWeight: "bold",
                                            backgroundColor: "#fff",
                                          }
                                        : {}
                                    }
                                  />
                                </td>
                                <td style={{ width: 100 }}>{obj.color}</td>


                              <td style={{ width: 60 }}>
                                {(() => {
                                  if (!obj.image_path) {
                                    return (
                                      <ImageNotSupportedIcon
                                        style={{ width: 60, height: 60, color: "#ccc" }}
                                      />
                                    );
                                  }

                                  const imageSrc =
                                    obj.isImageUrl === true
                                      ? obj.image_path
                                      : (obj.url_image || "") + obj.image_path;

                                  return (
                                    <img
                                      src={imageSrc}
                                      width="60"
                                      height="60"
                                      alt="product"
                                      style={{ objectFit: "cover", borderRadius: 4 }}
                                      onError={(e) => {
                                        e.target.onerror = null; // infinite loop prevent
                                        e.target.src = "/no-image.png";
                                      }}
                                    />
                                  );
                                })()}
                              </td>

                              <td style={{ width: 120 }}>
                                <div style={{ marginBottom: 6 }}>
                                  <Button size="sm" className="retailer-sales-editor-size-btn" onClick={() => toggleDetail(obj)} outline>Sizes</Button>
                                </div>
                                <div>
                                  <Button size="sm" color="danger" className="retailer-sales-editor-delete-btn" onClick={() => deleteRow(obj.product_id)}>Delete</Button>
                                </div>
                              </td>
                            </tr>
                            );
                          })
                      ) : (
                        <tr><td colSpan="6" className="text-center retailer-sales-editor-empty">No Data</td></tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>


              <Col sm={4}>

                <Card className="retailer-sales-editor-summary">
                  <CardHeader>Bill Summary</CardHeader>
                  <CardBody>
                    <Table borderless size="sm">
                      <tbody>
                        <tr>
                          <td>No. of items</td>
                          <td className="text-end">{totalItemsCount}</td>
                        </tr>
                        <tr>
                          <td>Subtotal</td>
                          <td className="text-end">₹{subtotalAmount.toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </CardBody>
                  <CardFooter className="d-flex gap-2 retailer-sales-editor-summary-footer">
                    <Button color="primary" className="flex-fill retailer-sales-editor-checkout-btn" onClick={generateBill} disabled={selectedProducts.length === 0}>Checkout</Button>
                  </CardFooter>
                </Card>


              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Details Modal */}
      <Modal isOpen={showDetailsModal} size="lg" backdrop="static" centered className="retailer-sales-editor-modal">
        <ModalHeader className="retailer-sales-editor-modal-header">
          <div className="retailer-sales-editor-modal-title">
            <span>Edit Sizes / Qty</span>
            <span>{detailProduct?.product_name || ""}</span>
          </div>
        </ModalHeader>
        <ModalBody style={{ maxHeight: 400, overflowY: "auto" }} className="retailer-sales-editor-modal-body">
          <Table bordered responsive className="retailer-sales-editor-modal-table">
            <thead>
              <tr>
                <th>Product</th><th>Color</th><th>Size</th><th>Price</th><th>Available</th><th>Qty to Add</th><th>Already Added</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {modalProducts && modalProducts.length > 0 ? (
                modalProducts.map((p) => {
                  const addedIdx = selectedProducts.findIndex(
                    (x) => x.product_id === p.product_id
                  );
                  const hasStockError = Boolean(stockErrors[p.product_id]);
                  const errorInfo = stockErrors[p.product_id];

                  const addedQty =
                    addedIdx > -1 ? selectedProducts[addedIdx].sale_qty : "";
                  return (
                    <tr
                      key={p.product_id}
                      style={
                        hasStockError
                          ? {
                              backgroundColor: "#ffebee",
                              borderLeft: "4px solid #d32f2f",
                            }
                          : {}
                      }
                    >
                      <td>
                        <span style={hasStockError ? { color: "#d32f2f", fontWeight: "bold" } : {}}>
                          {p.product_name} ({p.product_code})
                        </span>
                        {hasStockError && (
                          <div style={{ color: "#d32f2f", fontSize: "11px", fontWeight: "bold" }}>
                            ⚠ {errorInfo?.message || "Insufficient stock"}
                          </div>
                        )}
                      </td>
                      <td>{p.color}</td>
                      <td>{p.size_length}</td>
                      <td>{p.price}</td>
                      <td>{p.qty}</td>
                      <td>
                        <Input
                          type="number"
                          min="1"
                          value={p.sale_qty ?? ""}
                          onChange={(e) => {
                            const value = e.target.value === "" ? "" : Number(e.target.value);

                            // modal update
                            setModalProducts((prev) =>
                              prev.map((item) =>
                                item.product_id === p.product_id
                                  ? {
                                    ...item,
                                    sale_qty: value,
                                  }
                                  : item
                              )
                            );

                            // selected update
                            setSelectedProducts((prev) =>
                              prev.map((item) =>
                                item.product_id === p.product_id
                                  ? {
                                    ...item,
                                    sale_qty: value,
                                    qty: value,
                                  }
                                  : item
                              )
                            );

                            // main table update
                            setProductlist((prev) =>
                              prev.map((item) =>
                                item.product_id === p.product_id
                                  ? {
                                    ...item,
                                    sale_qty: value,
                                    qty: value,
                                  }
                                  : item
                              )
                            );
                          }}


                        />
                      </td>
                      <td>{addedQty}</td>
                      <td>
                        <Button
                          color={addedIdx > -1 ? "danger" : "success"}
                          size="sm"
                          onClick={() => {
                            if (addedIdx > -1) {
                              addOrRemoveProduct(p);
                              return;
                            }

                            const qtyToAdd = Number(p.sale_qty) || 0;

                            if (qtyToAdd <= 0) {
                              showErrorToast("Enter valid quantity");
                              return;
                            }

                            if (qtyToAdd > Number(p.qty)) {
                              showErrorToast("Qty cannot exceed available qty");
                              return;
                            }

                            addOrRemoveProduct(p, qtyToAdd);
                          }}
                        >
                          {addedIdx > -1 ? "Remove" : "Add"}
                        </Button>

                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr><td colSpan="8" className="text-center retailer-sales-editor-empty">No Data</td></tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter className="retailer-sales-editor-modal-footer">
          <Button color="secondary" className="retailer-sales-editor-cancel-btn" onClick={closeDetail}>Close</Button>
        </ModalFooter>
      </Modal>


      {/* Bill Modal */}
      <Modal isOpen={showBillModal} size="lg" zIndex="9999" centered backdrop="static" className="custom_modal retailer-sales-editor-modal retailer-sales-editor-invoice-modal">
        <ModalHeader className="retailer-sales-editor-modal-header">Invoice</ModalHeader>
        <ModalBody style={{ maxHeight: 520, overflowY: "auto" }} className="retailer-sales-editor-modal-body retailer-sales-editor-invoice-body">
          {billData ? (
            <>
              {/* 🧾 Header */}
              {/* <div style={{ textAlign: "center", marginBottom: 12 }} className="retailer-sales-editor-invoice-head">
                <h3>{branchDetails?.bill_describe || "Bill Details"}</h3>
                <div>{branchDetails?.address}</div>
                <div>{branchDetails?.mobile ? `Mobile: ${branchDetails.mobile}` : ""}</div>
                <div>{branchDetails?.gst_number ? `GST: ${branchDetails.gst_number}` : ""}</div>
              </div> */}

              <div
                style={{ textAlign: "center", marginBottom: 12 }}
                className="retailer-sales-editor-invoice-head"
              >
                {branchDetails?.bill_describe ? (
                  <>
                    <h3>{branchDetails.bill_describe.split("\n")[0]}</h3>

                    {branchDetails.bill_describe
                      .split("\n")
                      .slice(1)
                      .map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}
                  </>
                ) : (
                  <>
                    <h3>{branchDetails?.brand_name || "Bill Details"}</h3>
                    <div>{branchDetails?.address}</div>
                    <div>
                      {branchDetails?.mobile ? `Mobile: ${branchDetails.mobile}` : ""}
                    </div>
                    <div>
                      {branchDetails?.gst_number ? `GST: ${branchDetails.gst_number}` : ""}
                    </div>
                  </>
                )}
              </div>

              {/* 👤 Customer Info */}
              <div
                className="retailer-sales-editor-invoice-meta"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 8,
                }}
              >
                <div>
                  <strong>Customer:</strong> {billData.customer} <br />
                  <strong>Mobile:</strong> {billData.mobile}
                </div>
                <div style={{ textAlign: "right" }}>
                  <strong>Entry No.:</strong> {param.entry_no} <br />
                  <strong>Date:</strong> {new Date().toLocaleDateString("en-GB")}
                </div>
              </div>

              {/* 🧮 Product Table */}
              <Table bordered responsive className="retailer-sales-editor-modal-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Color</th>
                    <th>Qty</th>
                    <th>Size</th>
                    <th>Price</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {billData.products && billData.products.length > 0 ? (
                    billData.products.map((p, i) => {
                      const gstPercent = Number(p.gst) || 0;
                      const priceWithGST = Number(p.price) || 0;
                      const priceWithoutGST =
                        branchDetails?.gst_type === "Inclusive"
                          ? priceWithGST / (1 + gstPercent / 100)
                          : priceWithGST;
                      const hasStockError = Boolean(stockErrors[p.product_id]);
                      const errorInfo = stockErrors[p.product_id];

                      return (
                        <tr
                          key={i}
                          style={
                            hasStockError
                              ? {
                                  backgroundColor: "#ffebee",
                                  borderLeft: "4px solid #d32f2f",
                                }
                              : {}
                          }
                        >
                          <td>
                            <span style={hasStockError ? { color: "#d32f2f", fontWeight: "bold" } : {}}>
                              {p.product_name}
                            </span>
                            {hasStockError && (
                              <div
                                style={{
                                  color: "#d32f2f",
                                  fontSize: "11px",
                                  fontWeight: "bold",
                                  marginTop: "2px",
                                }}
                              >
                                ⚠ {errorInfo?.message || "Stock error"}
                              </div>
                            )}
                          </td>
                          <td>{p.color}</td>
                          <td>
                            <span style={hasStockError ? { color: "#d32f2f", fontWeight: "bold" } : {}}>
                              {p.qty}
                            </span>
                          </td>
                          <td>{p.size_length}</td>
                          <td>{priceWithoutGST.toFixed(2)}</td>
                          <td>{(priceWithoutGST * p.qty).toFixed(2)}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No products found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {/* 💰 Subtotal */}
              <Row className="mt-2 mb-3 retailer-sales-editor-invoice-totals">
                <Col>
                  <h5>
                    <strong>Subtotal (Without GST):</strong> ₹
                    {billData.products
                      ? billData.products
                        .reduce((acc, p) => {
                          const gstPercent = Number(p.gst) || 0;
                          const priceWithGST = Number(p.price) || 0;
                          const priceWithoutGST =
                            branchDetails?.gst_type === "Inclusive"
                              ? priceWithGST / (1 + gstPercent / 100)
                              : priceWithGST;
                          return acc + priceWithoutGST * p.qty;
                        }, 0)
                        .toFixed(2)
                      : "0.00"}
                  </h5>
                </Col>
                <Col style={{ textAlign: "right" }}>
                  <h5>
                    <strong>Total Items:</strong> {billData.totalItems}
                  </h5>
                </Col>
              </Row>

              {/* 🎟️ Redeem & Discounts */}
              <Row className="retailer-sales-editor-redeem-row">
                {/* Point Redeem */}
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      <strong>
                        Point Redeem <span style={{ color: "red" }}>({totalPoint})</span>:
                      </strong>
                    </Label>
                    <Input
                      type="number"
                      placeholder="Enter Redeem Point"
                      value={redeemPoint}
                      onChange={handleRedeemChange}
                    />
                    {errorMsg && <small style={{ color: "red" }}>{errorMsg}</small>}
                  </FormGroup>


                </Col>

                {/* Voucher Redeem */}
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      <strong>
                        Voucher Redeem <span style={{ color: "red" }}>({voucherCount})</span>:
                      </strong>
                    </Label>
                    <Input
                      type="select"
                      value={voucherDetail?.voucher_id || ""}
                      onChange={(e) => {
                        const selectedVoucher = CustomerVoucherList.find(
                          (v) => v.voucher_id.toString() === e.target.value
                        );
                        console.log("Selected Voucher", selectedVoucher);
                        if (selectedVoucher) {
                          setVoucherDetail({
                            tran_id: selectedVoucher.tran_id,
                            voucher_id: selectedVoucher.voucher_id,
                            voucher_name: selectedVoucher.voucher_name,
                            amount: selectedVoucher.amount,
                          });

                          setRedeemVoucherData((prev) => ({
                            ...prev,
                            tran_id: selectedVoucher.tran_id,
                            voucher_id: selectedVoucher.voucher_id,
                          }));

                          setBillingSummary((prev) => ({
                            ...prev,
                            voucher_id: selectedVoucher.voucher_id,
                            voucher_name: selectedVoucher.voucher_name,
                          }));
                        } else {
                          setVoucherDetail({});
                          setRedeemVoucherData({});
                          setBillingSummary((prev) => ({
                            ...prev,
                            voucher_id: "",
                            voucher_name: "",
                          }));
                        }
                      }}
                    >
                      <option value="">-- Select Voucher --</option>
                      {CustomerVoucherList?.map((v, i) => (
                        <option key={i} value={v.voucher_id}>
                          {v.voucher_name} - {v.amount}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                {/* Special Discount */}
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      <strong>Special Discount:</strong>
                    </Label>
                    <Input
                      type="text"
                      placeholder="Enter Special Discount (e.g. 100 or 10%)"
                      value={billData.special_discount || ""}
                      onChange={(e) => {
                        setBillData((b) => ({ ...b, special_discount: e.target.value }));
                        setBillingSummary((prev) => ({
                          ...prev,
                          special_discount: e.target.value,
                        }));
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* 🧾 Discount & GST Summary */}
              <div style={{ borderTop: "1px solid #ddd", paddingTop: 8 }} className="retailer-sales-editor-discount-summary">
                {(() => {
                  const subtotal = billData.products?.reduce((acc, p) => {
                    const gstPercent = Number(p.gst) || 0;
                    const priceWithGST = Number(p.price) || 0;
                    const priceWithoutGST =
                      branchDetails?.gst_type === "Inclusive"
                        ? priceWithGST / (1 + gstPercent / 100)
                        : priceWithGST;
                    return acc + priceWithoutGST * p.qty;
                  }, 0) || 0;

                  // 🧮 Point Discount
                  const pointPerRs = Number(branchDetails?.rupees_per_point) || 0;
                  let pointDiscount =
                    redeemPoint ? (pointPerRs > 0 ? Number(redeemPoint) / pointPerRs : Number(redeemPoint)) : 0;
                  let pointDiscountRaw =
                    redeemPoint ? (pointPerRs > 0 ? Number(redeemPoint) / pointPerRs : Number(redeemPoint)) : 0;
                  // 🧾 Voucher Discount - detects type
                  let voucherDiscountRaw = 0;
                  const vAmt = voucherDetail?.amount;

                  if (vAmt) {
                    if (!isNaN(vAmt)) {
                      // Direct numeric value
                      voucherDiscountRaw = Number(vAmt);
                    } else {
                      const percentMatch = String(vAmt).match(/(\d+(\.\d+)?)\s*%/);

                      const rsMatch = String(vAmt).match(
                        /(?:Rs\.?|Get\s*Rs\.?)\s*(\d+(\.\d+)?)/i
                      );

                      if (percentMatch) {
                        voucherDiscountRaw =
                          (subtotal * parseFloat(percentMatch[1])) / 100;
                      } else if (rsMatch) {
                        voucherDiscountRaw = parseFloat(rsMatch[1]);
                      }
                    }
                  }

                  // ✳️ Special Discount
                  const sp = billData.special_discount || "";
                  const isPercent = sp.includes("%");
                  const specialDiscountRaw = isPercent
                    ? (subtotal * parseFloat(sp)) / 100
                    : parseFloat(sp || 0);
                  const chargeAmountRaw = Number(extraCharge.amount || 0);
                  let voucherDiscount = voucherDiscountRaw;
                  let specialDiscount = specialDiscountRaw;
                  let chargeAmount = chargeAmountRaw;

                  if (branchDetails?.gst_type === "Inclusive") {
                    const gstPercent =
                      billData.products?.length > 0
                        ? Number(billData.products[0].gst || 0)
                        : 0;

                    const divisor = 1 + gstPercent / 100;

                    pointDiscount = pointDiscountRaw / divisor;
                    voucherDiscount = voucherDiscountRaw / divisor;
                    specialDiscount = specialDiscountRaw / divisor;
                    chargeAmount = chargeAmountRaw / divisor;
                  }
                  const subtotalAfterDiscounts = Math.max(
                    subtotal - (pointDiscount + voucherDiscount + specialDiscount),
                    0
                  );

                  const subtotalAfterExtraCharges =
                    subtotalAfterDiscounts + chargeAmount;

                  // 💸 GST
                  let cgst = 0,
                    sgst = 0,
                    igst = 0,
                    gstPercent = 0;
                  if (billData.products?.length) {
                    gstPercent = Number(billData.products[0].gst) || 0;
                  }

                  if (branchDetails?.gst_mode === "CGST/SGST") {
                    const half = gstPercent / 2;
                    cgst = (subtotalAfterExtraCharges * half) / 100;
                    sgst = (subtotalAfterExtraCharges * half) / 100;
                  } else if (branchDetails?.gst_mode === "IGST") {
                    igst = (subtotalAfterExtraCharges * gstPercent) / 100;
                  }



                  const finalAmount =
                    subtotalAfterExtraCharges +
                    cgst +
                    sgst +
                    igst;

                  return (
                    <>
                      <Row>
                        <Col>
                          {pointDiscount > 0 && <p><strong>Point Discount:</strong> ₹{pointDiscount.toFixed(2)}</p>}
                          {voucherDiscount > 0 && <p><strong>Voucher Discount:</strong> ₹{voucherDiscount.toFixed(2)}</p>}
                          {specialDiscount > 0 && <p><strong>Special Discount:</strong> ₹{specialDiscount.toFixed(2)}</p>}
                          {(pointDiscount > 0 || voucherDiscount > 0 || specialDiscount > 0) && (
                            <>
                              <p><strong>Subtotal After Discounts:</strong> ₹{subtotalAfterDiscounts.toFixed(2)}</p>
                              <hr style={{ borderTop: "1px dashed #ccc", margin: "8px 0" }} />
                            </>
                          )}
                          <Row className="mt-2">
                            <Col md={6}>

                              <FormGroup>
                                {/* <Label><strong>Charge Name</strong></Label> */}
                                <Input
                                  type="text"
                                  placeholder="Packing Charge / Delivery Charge"
                                  value={extraCharge.name}
                                  onChange={(e) =>
                                    setExtraCharge({
                                      ...extraCharge,
                                      name: e.target.value,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col md={6}>
                              <FormGroup>
                                {/* <Label><strong>Charge Amount</strong></Label> */}
                                <Input
                                  type="number"
                                  placeholder="Enter Amount"
                                  value={extraCharge.amount}
                                  onChange={(e) =>
                                    setExtraCharge({
                                      ...extraCharge,
                                      amount: e.target.value,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          {chargeAmount > 0 && (
                            <>
                              <p>
                                <strong>{extraCharge.name || "Extra Charge"}:</strong>
                                ₹{chargeAmount.toFixed(2)}
                              </p>

                              <p>
                                <strong>
                                  Subtotal After {extraCharge.name || "Extra Charge"}:
                                </strong>
                                ₹{subtotalAfterExtraCharges.toFixed(2)}
                              </p>
                              <hr style={{ borderTop: "1px dashed #ccc", margin: "8px 0" }} />
                            </>
                          )}

                          {branchDetails?.gst_mode === "CGST/SGST" && (
                            <>
                              <p><strong>CGST ({(gstPercent / 2).toFixed(2)}%):</strong> ₹{cgst.toFixed(2)}</p>
                              <p><strong>SGST ({(gstPercent / 2).toFixed(2)}%):</strong> ₹{sgst.toFixed(2)}</p>
                            </>
                          )}
                          {branchDetails?.gst_mode === "IGST" && (
                            <p><strong>IGST ({gstPercent.toFixed(2)}%):</strong> ₹{igst.toFixed(2)}</p>
                          )}
                        </Col>

                        <Col style={{ textAlign: "right" }}>
                          <h5><strong>Final Amount:</strong> ₹{finalAmount.toFixed(2)}</h5>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label><strong>NOTE :</strong></Label>
                            <Input
                              type="textarea"
                              rows="4"
                              placeholder="Write a Note"
                              value={note}
                              onChange={(e) => setNote(e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      {
                        param.address ?
                          <Row>
                            <Col>
                              <FormGroup>
                                <Label><strong>Delivery Address :</strong></Label>
                                <Input
                                  type="text"
                                  rows="4"
                                  value={param.address}
                                  disabled
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          :
                          ""
                      }
                    </>
                  );
                })()}
              </div>
            </>
          ) : (
            <div className="text-center text-muted">No bill data available</div>
          )}
        </ModalBody>
        <ModalFooter className="retailer-sales-editor-modal-footer">
          <Button color="primary" className="retailer-sales-editor-action-btn" onClick={handlePrint}>Print</Button>
          <Button color="success" className="retailer-sales-editor-action-btn" onClick={saveData} disabled={saveLoading}>
            {saveLoading ? "Saving..." : "Save"}
          </Button>
          <Button color="secondary" className="retailer-sales-editor-cancel-btn" onClick={() => setShowBillModal(false)}>Close</Button>
        </ModalFooter>
      </Modal>

      {/* bottom actions */}
      <Row className="retailer-sales-editor-bottom-actions">
        <Col
          className="d-flex justify-content-end"
          style={{ gap: "10px" }}
        >
          <Button color="secondary" className="retailer-sales-editor-cancel-btn" onClick={() => history.goBack()}>Cancel</Button>
        </Col>
      </Row>

    </>
  );
};

export default AddCustomerSales;
